var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphicDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 740.433,
    height: 646.194,
    viewBox: "0 0 740.433 646.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graphic_design",
    "data-name": "graphic design",
    transform: "translate(-140 -3546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511",
    transform: "translate(6153.19 1857.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M2952.139,1552.3c0,173.758-41.754,286.338-280.792,315.268-88.688,10.734-101.18-138.827-199.228-137.347-143.812,2.17-166.161-100.895-157.415-141.036,27.717-127.223,235.469-438.064,358.558-346.078C2914.243,1423.2,2952.139,1378.547,2952.139,1552.3Z",
    transform: "translate(-8282.227 461.76)",
    fill: "#0095ff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M3008.85,1563.513c0,173.758-210.86,233.25-443.067,302.973-142.488,42.784-317.775-152.174-295.427-300.8,28.567-189.978,217.979-381.651,341.068-289.665C2852.406,1456.109,3008.85,1389.756,3008.85,1563.513Z",
    transform: "translate(-8281.607 461.4)",
    fill: "#0095ff",
    opacity: 0.09
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    transform: "translate(168.244 3578.019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904",
    transform: "translate(78.148 54.981)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(441.972 65.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887",
    transform: "translate(5.131 5.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M431.481,162.037H429.3v-1.454h.727v-.727h1.454Z",
    transform: "translate(-347.681 -78.236)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M450.244,161.81H447.3v-1.454h2.943Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0h-2.943v-1.454h2.943Zm-5.884,0h-2.943v-1.454h2.943Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0H412v-1.454h2.942Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0h-2.943v-1.454h2.943Zm-5.884,0h-2.942v-1.454h2.942Zm-5.884,0h-2.942v-1.454H391.4Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0H376.69v-1.454h2.941Z",
    transform: "translate(-371.567 -78.009)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M375.348,162.037h-2.181v-2.181h1.454v.727h.727Z",
    transform: "translate(-373.167 -78.236)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M374.621,180.8h-1.454v-2.941h1.454Zm0-5.884h-1.454v-2.941h1.454Zm0-5.884h-1.454v-2.941h1.454Zm0-5.884h-1.454V160.2h1.454Zm0-5.884h-1.454V154.32h1.454Zm0-5.884h-1.454v-2.941h1.454Zm0-5.884h-1.454v-2.941h1.454Zm0-5.883h-1.454v-2.943h1.454Zm0-5.886h-1.454v-2.941h1.454Zm0-5.884h-1.454V124.9h1.454Zm0-5.883h-1.454v-2.943h1.454Zm0-5.884h-1.454v-2.943h1.454Zm0-5.884h-1.454v-2.943h1.454Z",
    transform: "translate(-373.166 -102.122)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M374.621,105.9h-1.454v-2.181h2.181v1.454h-.727Z",
    transform: "translate(-373.167 -103.722)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M450.244,105.176H447.3v-1.454h2.943Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0H429.65v-1.454h2.941Zm-5.884,0h-2.943v-1.454h2.943Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0H412v-1.454h2.942Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0h-2.941v-1.454h2.941Zm-5.883,0h-2.943v-1.454h2.943Zm-5.886,0h-2.942v-1.454H391.4Zm-5.884,0h-2.941v-1.454h2.941Zm-5.884,0H376.69v-1.454h2.941Z",
    transform: "translate(-371.567 -103.722)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M431.481,105.9h-1.454v-.727H429.3v-1.454h2.181Z",
    transform: "translate(-347.681 -103.722)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M431.254,180.8H429.8v-2.941h1.454Zm0-5.884H429.8v-2.941h1.454Zm0-5.884H429.8v-2.941h1.454Zm0-5.883H429.8V160.2h1.454Zm0-5.884H429.8V154.32h1.454Zm0-5.886H429.8v-2.941h1.454Zm0-5.884H429.8v-2.941h1.454Zm0-5.883H429.8v-2.943h1.454Zm0-5.884H429.8v-2.943h1.454Zm0-5.884H429.8V124.9h1.454Zm0-5.884H429.8v-2.943h1.454Zm0-5.884H429.8v-2.943h1.454Zm0-5.884H429.8v-2.943h1.454Z",
    transform: "translate(-347.454 -102.122)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    transform: "translate(0 82.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.726 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M381.353,168.542H369.638V156.827h11.715Zm-10.261-1.454H379.9v-8.807h-8.807Z",
    transform: "translate(-369.638 -156.827)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889",
    transform: "translate(0 41.173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.726 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M381.353,140.226H369.638V128.51h11.715Zm-10.261-1.454H379.9v-8.808h-8.807Z",
    transform: "translate(-369.638 -128.51)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.726 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M381.353,111.908H369.638V100.193h11.715Zm-10.261-1.454H379.9v-8.807h-8.807Z",
    transform: "translate(-369.638 -100.193)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(82.347 82.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.727 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M437.987,168.542H426.272V156.827h11.715Zm-10.261-1.454h8.807v-8.807h-8.807Z",
    transform: "translate(-426.272 -156.827)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(82.347 41.173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.727 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M437.987,140.226H426.272V128.51h11.715Zm-10.261-1.454h8.807v-8.808h-8.807Z",
    transform: "translate(-426.272 -128.51)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893",
    transform: "translate(82.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.727 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M437.987,111.908H426.272V100.193h11.715Zm-10.261-1.454h8.807v-8.807h-8.807Z",
    transform: "translate(-426.272 -100.193)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894",
    transform: "translate(41.173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.727 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M409.67,111.908H397.955V100.193H409.67Zm-10.261-1.454h8.807v-8.807h-8.807Z",
    transform: "translate(-397.955 -100.193)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895",
    transform: "translate(41.173 82.347)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.727 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M409.67,168.542H397.955V156.827H409.67Zm-10.261-1.454h8.807v-8.807h-8.807Z",
    transform: "translate(-397.955 -156.827)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(18.734 17.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M411.816,151.477H395.384l-6.39,17.925h6.225v1.576h-12.7V169.4h3.9l21.162-57.01h6.8L435.3,169.4h3.817v1.576H411.982V169.4h5.89Zm-15.686-1.825h15.021l-7.221-21.743Z",
    transform: "translate(-382.522 -112.392)",
    fill: "#dbdbdb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898",
    transform: "translate(37.245 7.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M127.158,87.1s-.285,16.176-10.642,34.52h-14.59C91.57,103.272,91.286,87.1,91.286,87.1c14.982-8.379,15.373-27.135,15.373-27.135h1.512v29.7a4.573,4.573,0,1,0,2.1,0v-29.7h1.512S112.176,78.716,127.158,87.1Z",
    transform: "translate(-91.286 -59.961)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 21.557,
    height: 9.073,
    transform: "translate(7.157 59.878)",
    fill: "#c7c7c7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M169.3,108.973h-1.454a48.6,48.6,0,1,0-97.192,0H69.2a50.05,50.05,0,1,1,100.1,0Z",
    transform: "translate(-64.069 -53.191)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 99.772,
    height: 1.454,
    transform: "translate(4.731 5.131)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899",
    transform: "translate(0 49.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.726 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M77.387,101.032H65.671V89.317H77.387ZM67.125,99.578h8.808V90.771H67.125Z",
    transform: "translate(-65.671 -89.317)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.726 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M77.387,66.7H65.671V54.981H77.387ZM67.125,65.243h8.808V56.435H67.125Z",
    transform: "translate(-65.671 -54.981)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901",
    transform: "translate(98.646 49.925)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.726 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M145.23,101.032H133.515V89.317H145.23Zm-10.261-1.454h8.807V90.771h-8.807Z",
    transform: "translate(-133.515 -89.317)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    transform: "translate(98.646)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 10.262,
    height: 10.262,
    transform: "translate(0.726 0.727)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M145.23,66.7H133.515V54.981H145.23Zm-10.261-1.454h8.807V56.435h-8.807Z",
    transform: "translate(-133.515 -54.981)",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905",
    transform: "translate(46.573 83.472)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 38.503,
    height: 16.27,
    transform: "translate(577.706 375.592) rotate(180)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 38.503,
    height: 16.27,
    transform: "translate(599.184 396.108) rotate(180)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 38.503,
    height: 16.27,
    transform: "translate(556.227 396.108) rotate(180)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 38.503,
    height: 16.27,
    transform: "translate(59.981 396.108) rotate(180)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 38.503,
    height: 16.27,
    transform: "translate(59.981 16.27) rotate(180)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 38.503,
    height: 16.27,
    transform: "translate(38.503 36.786) rotate(180)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 38.503,
    height: 16.27,
    transform: "translate(599.184 16.288) rotate(180)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 38.503,
    height: 16.27,
    transform: "translate(179.353 287.345)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 38.503,
    height: 16.27,
    transform: "translate(157.875 266.829)",
    fill: "none",
    stroke: "#ebebeb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 598.036,
    transform: "translate(47.147 539.527)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922",
    transform: "translate(38.19 354.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908",
    transform: "translate(66.541 22.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M122.817,291.248c-4.582-4.489-10.5-9.912-17.506-7.977-6.59,1.82-9.112,9.013-10.291,15.007-1.521,7.724-2.7,15.523-3.93,23.3q-1.858,11.78-3.533,23.585-.955,6.661-1.889,13.323-.465,3.333-.926,6.665c-.3,2.18-.666,4.356-.787,6.555-.038.7,1.061.8,1.214.134.849-3.7,1.2-7.558,1.745-11.318q.82-5.673,1.647-11.346,1.647-11.267,3.366-22.526,1.7-11.265,3.5-22.515c1.016-6.36,1.5-14.262,7.135-18.457,3.093-2.3,7.039-2.326,10.545-.989,3.711,1.416,6.675,4.073,9.578,6.7A.1.1,0,0,0,122.817,291.248Z",
    transform: "translate(-83.953 -273.415)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907",
    transform: "translate(17.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M111.159,289.613s-9.365-3.372-13.986,3.464.9,24.218,43.542,34.025a120.407,120.407,0,0,0-10.26-38.544C121.316,268.623,105.028,276.172,111.159,289.613Z",
    transform: "translate(-95.821 -276.367)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    transform: "translate(10.193 10.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M134.99,320.336a33.27,33.27,0,0,0-2.145-3.458q-1.069-1.649-2.162-3.282c-.548-.819-1.108-1.63-1.668-2.441.041-.2.052-.4.079-.611.049-.369.1-.739.147-1.106.1-.8.221-1.6.339-2.395s.25-1.588.4-2.379a12.681,12.681,0,0,1,.558-2.513c.054-.124-.17-.186-.186-.039a9.251,9.251,0,0,1-.381,1.412c-.1.358-.193.718-.286,1.077q-.31,1.213-.586,2.436c-.169.75-.311,1.5-.439,2.264-.061.363-.115.728-.164,1.093-.76-1.085-1.535-2.158-2.335-3.212-2.264-2.982-4.659-5.852-7.136-8.653.01-.028.036-.044.038-.077.221-4.48.113-8.914,1.108-13.322.026-.121-.154-.186-.182-.065-.932,4.134-1.861,8.475-1.594,12.746q-1.333-1.49-2.7-2.956-3.114-3.348-6.353-6.582c-.087-.087-.225.041-.141.131,3.593,3.868,7.005,7.9,10.329,12a73.394,73.394,0,0,0-7.795.288c-2.891.214-5.764.583-8.634.98-.122.017-.086.208.036.189a81.168,81.168,0,0,1,8.622-.772c2.782-.115,5.549.01,8.327,0q2.694,3.341,5.323,6.732c-.125,0-.256,0-.4-.007-.653-.013-1.307-.023-1.96-.012-1.3.022-2.594.113-3.884.222A59.142,59.142,0,0,0,111.3,309.2a.1.1,0,0,0,.036.189c2.62-.3,5.246-.541,7.881-.634,1.258-.044,2.514-.044,3.772-.044.654,0,1.307-.006,1.961,0a2.47,2.47,0,0,0,1.076-.1c1.147,1.489,2.3,2.978,3.431,4.474q1.357,1.786,2.674,3.6c.9,1.239,1.706,2.591,2.7,3.75C134.909,320.532,135.037,320.432,134.99,320.336Z",
    transform: "translate(-102.74 -282.615)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M112.055,292.207a28.448,28.448,0,0,0-4.561-.222c-1.521,0-3.043.045-4.564.1a.1.1,0,1,0,.012.19c1.543-.111,3.084-.137,4.63-.113,1.492.022,2.988.164,4.478.124A.038.038,0,0,0,112.055,292.207Z",
    transform: "translate(-102.831 -279.445)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M118.6,295.9c.174-1.455.356-2.92.667-4.353a.1.1,0,1,0-.186-.039c-.22,1.434-.5,2.857-.71,4.292q-.159,1.075-.292,2.156a9.975,9.975,0,0,0-.174,2.033.131.131,0,0,0,.25.019,12.6,12.6,0,0,0,.221-2.03Q118.474,296.937,118.6,295.9Z",
    transform: "translate(-95.993 -279.701)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M116.924,283.424c-.374,1.418-.743,2.851-1,4.3-.132.731-.244,1.467-.343,2.2a8.858,8.858,0,0,0-.144,2.153.059.059,0,0,0,.112.009,12.209,12.209,0,0,0,.336-2.054q.142-1.062.326-2.12c.259-1.486.522-2.959.9-4.422C117.136,283.37,116.956,283.3,116.924,283.424Z",
    transform: "translate(-97.121 -283.361)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910",
    transform: "translate(16.632 62.524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M84.816,359.054q-.353-4.026-.779-8.047-.842-7.969-1.922-15.907c-.71-5.277-1.389-10.566-2.236-15.824a39.481,39.481,0,0,0-1.627-7.184,6.816,6.816,0,0,0-3.98-4.49c-5.016-1.733-8.4,3.469-10.427,7.149-.061.111.1.193.169.093,1.213-1.742,4.566-6.638,8.371-6.409,2.561.154,4.609,1.967,5.838,8.352,3.064,15.91,5.823,48.2,6.146,50.307.172,1.12.963,1.072.968-.128C85.353,364.326,85.046,361.683,84.816,359.054Z",
    transform: "translate(-43.181 -302.864)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M71.647,314.145s4.384-15.482-5.309-7.741c-16.137,12.887-16.71,40.92-16.71,40.92s28.683-16.66,32.25-27.649C87.192,303.307,71.647,314.145,71.647,314.145Z",
    transform: "translate(-49.629 -304.236)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(1.821 7.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M76.506,319.261c-2.251.455-4.532.755-6.806,1.082q-1.612.231-3.228.454c-.727.1-1.463.169-2.194.259,2.137-2.944,4.291-5.876,6.34-8.878.08-.116-.1-.236-.192-.141a66.492,66.492,0,0,0-4.792,5.531c-.42-1.2-.851-2.395-1.272-3.593-.487-1.387-1.012-2.766-1.364-4.195-.031-.121-.218-.064-.185.055.391,1.419.669,2.867,1.048,4.291.366,1.374.784,2.732,1.271,4.067-1.051,1.365-2.057,2.763-3.037,4.173-.494-1.4-1.106-2.752-1.538-4.173a.1.1,0,0,0-.185.055c.513,1.572.791,3.206,1.274,4.787-.659.961-1.317,1.924-1.945,2.895-1.159,1.79-2.249,3.612-3.318,5.447a.427.427,0,0,0-.252.433c-1.812,3.135-3.536,6.316-5.236,9.525a.1.1,0,0,0,.167.093c1.7-3.17,3.6-6.255,5.567-9.287l.02,0a4.3,4.3,0,0,1,.938-.182c.332-.068.662-.143.992-.215.742-.161,1.476-.353,2.213-.537,1.454-.361,2.893-.7,4.371-.958.122-.022.067-.208-.055-.185-1.736.33-3.478.528-5.233.731-.829.1-1.655.2-2.478.333l-.119.017q1.546-2.351,3.136-4.66c1.043-1.512,2.113-3.005,3.189-4.494.995-.14,1.98-.4,2.968-.59q1.664-.318,3.328-.647c2.222-.439,4.432-.936,6.665-1.307C76.682,319.423,76.63,319.234,76.506,319.261Z",
    transform: "translate(-50.882 -309.712)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M57.035,318.544c-.134-.409-.257-.822-.387-1.232a24.513,24.513,0,0,1-.659-2.6c-.025-.121-.209-.065-.185.057.188.874.393,1.745.593,2.616a16.944,16.944,0,0,0,.746,2.575.174.174,0,0,0,.333-.1C57.353,319.418,57.179,318.984,57.035,318.544Z",
    transform: "translate(-48.648 -307.47)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M73,313.813c-1.309.2-2.629.288-3.945.4s-2.629.3-3.942.5c-.073.01-.074.121,0,.115,1.322-.09,2.632-.192,3.946-.365s2.622-.366,3.943-.458C73.133,314,73.123,313.8,73,313.813Z",
    transform: "translate(-44.443 -307.85)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913",
    transform: "translate(0 7.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M108.528,355.6c-.509-11.4-1.233-22.78-2.379-34.136-.57-5.655-1.208-11.3-2.005-16.932a121.015,121.015,0,0,0-3.266-16.39c-1.173-4.1-2.715-8.222-5.455-11.555A12.387,12.387,0,0,0,84.4,271.776c-4.99.617-9.006,3.76-12.481,7.176-3.9,3.831-7.468,8.013-11.08,12.112q-1.37,1.555-2.718,3.13c-.08.093.058.227.14.132,3.53-4.055,7.2-8,11.036-11.763,3.546-3.482,7.2-7.287,12.112-8.726a12.481,12.481,0,0,1,7.037-.166,11.166,11.166,0,0,1,4.808,3.045c2.764,2.876,4.318,6.773,5.422,10.543,3.065,10.478,4.163,21.466,5.3,32.286,1.157,10.994,1.938,22.018,2.491,33.058.555,11.1.989,22.21,2.057,33.275.132,1.367.31,2.728.483,4.089.118.916,1.538.917,1.463-.036C109.566,378.5,109.04,367.056,108.528,355.6Z",
    transform: "translate(-29.152 -263.926)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M80.33,282.611s6.51-12.048-1.182-15.913S45.712,291.571,38.19,333.592c0,0,41.58-18.4,55.7-36.728S92,274.5,80.33,282.611Z",
    transform: "translate(-38.19 -266.351)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911",
    transform: "translate(6.503 13.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M84.412,288.049c-4.673.01-9.333-.355-14.008-.321.875-1,1.748-2.011,2.633-3.008a43.791,43.791,0,0,0,3.652-4.244c.065-.1-.074-.234-.169-.16a34.068,34.068,0,0,0-3.536,3.546q-1.756,1.865-3.494,3.746c-1.787,1.932-3.536,3.9-5.282,5.866,0-.192-.009-.381-.007-.567,0-.817,0-1.636,0-2.454.01-1.585.033-3.17.049-4.755.031-3.212.023-6.443.246-9.649.009-.124-.183-.118-.192,0-.224,3.224-.557,6.433-.715,9.66-.079,1.585-.116,3.17-.135,4.758-.01.817-.023,1.637-.017,2.454,0,.446-.013.917.02,1.377-.272.308-.554.608-.826.916-3.73,4.263-7.274,8.67-10.728,13.156,0-.247-.038-.5-.061-.744-.048-.494-.108-.989-.163-1.483-.121-1.073-.268-2.14-.427-3.208q-.227-1.5-.478-3c-.189-1.122-.464-2.261-.55-3.4a.1.1,0,1,0-.188.031,29.933,29.933,0,0,1,.391,3.421q.144,1.542.285,3.085c.092,1.029.185,2.057.291,3.087.051.494.095.989.148,1.483.026.247.057.494.09.74a1.427,1.427,0,0,0,.2.589c-.593.773-1.189,1.544-1.777,2.322-2.358,3.12-4.672,6.276-6.988,9.428-.071.1.064.231.14.132,2.193-2.859,4.448-5.666,6.734-8.448,1.711.073,3.456-.054,5.166-.081,1.8-.031,3.607-.039,5.41-.045a.1.1,0,0,0,0-.192c-1.8.031-3.606.058-5.409.065-1.643.006-3.321-.074-4.965.015q3.014-3.666,6.079-7.293c.742-.884,1.489-1.764,2.233-2.648a10.206,10.206,0,0,0,2.087.07q1.23,0,2.459,0c1.537-.006,3.072-.041,4.608-.064,3.174-.049,6.35-.154,9.522-.163a.1.1,0,0,0,0-.192c-3.177-.039-6.355-.176-9.533-.256-1.537-.039-3.075-.09-4.612-.11-.82-.012-1.64-.019-2.459-.028-.467-.006-.948-.038-1.421-.02q2.615-3.106,5.237-6.209a.235.235,0,0,0,.1-.113c1.7-2.009,3.408-4.02,5.131-6.014.236-.273.475-.541.712-.814,4.845.151,9.682-.167,14.526-.073C84.54,288.243,84.536,288.047,84.412,288.049Z",
    transform: "translate(-42.662 -275.957)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M70.111,289.955l-1.133.01c-.111,0-.106.172,0,.173l1.133.009C70.239,290.148,70.234,289.954,70.111,289.955Z",
    transform: "translate(-30.751 -269.602)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M70.772,290.033q-2.246-.03-4.491-.095-1.121-.03-2.245-.071a8.369,8.369,0,0,0-2.089.025c-.073.017-.06.121,0,.14a8.049,8.049,0,0,0,2.092.148q1.123.02,2.245.032,2.244.022,4.489.014A.1.1,0,0,0,70.772,290.033Z",
    transform: "translate(-33.929 -269.667)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M61.892,299.874a62.327,62.327,0,0,0-9.2-.829c-.045,0-.041.063,0,.067,3.055.291,6.116.457,9.147.949C61.968,300.082,62.014,299.892,61.892,299.874Z",
    transform: "translate(-38.121 -265.475)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M50.774,292.315c-.031-.268-.061-.535-.1-.8-.079-.6-.173-1.2-.268-1.8q-.27-1.712-.6-3.415c-.02-.106-.2-.079-.189.031q.216,1.76.38,3.529c.054.579.1,1.159.15,1.738a4.841,4.841,0,0,0,.234,1.647c.087.179.356.106.4-.063A2.244,2.244,0,0,0,50.774,292.315Z",
    transform: "translate(-39.501 -271.293)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916",
    transform: "translate(62.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M97.643,268.83c-1.489-2.77-3.382-6.43-7.1-6.2-3.068.192-4.449,3.321-5.105,5.909-2.025,8-2.168,16.443-2.562,24.643-.835,17.33-1.583,34.681-1.694,52.035q-.044,7.215.032,14.43c.045,4.906.032,9.839.343,14.736a.362.362,0,0,0,.723-.017c.026-4.2-.122-8.4-.14-12.592q-.024-6.144.081-12.285.2-12.441.664-24.875c.3-8.24.667-16.475,1.016-24.712q.262-6.174.534-12.349c.18-3.988.353-7.98.808-11.948.256-2.222.585-4.445,1.048-6.633a9.227,9.227,0,0,1,1.918-4.445,4.192,4.192,0,0,1,5.422-.393,11.489,11.489,0,0,1,3.843,4.8C97.535,269.043,97.7,268.941,97.643,268.83Z",
    transform: "translate(-81.17 -260.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(7.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M94.273,268.138s-3.053-10.786,3.7-5.393c11.24,8.977,11.638,28.5,11.638,28.5s-19.98-11.606-22.465-19.26C83.445,260.588,94.273,268.138,94.273,268.138Z",
    transform: "translate(-86.375 -261.235)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914",
    transform: "translate(4.87 5.81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M103.887,280.815c-.185-.3-.381-.587-.569-.884a5.538,5.538,0,0,0,0-.919c0-.464-.006-.929,0-1.393q.033-1.365.1-2.732c.006-.124-.186-.118-.192,0q-.07,1.341-.108,2.681c-.013.448-.033.894-.048,1.342-.006.174-.028.375-.038.576-.785-1.219-1.589-2.424-2.422-3.609-.243-.343-.5-.678-.742-1.018a20.955,20.955,0,0,1-.06-3.523c.015-1.253.032-2.505.076-3.759,0-.124-.189-.119-.192,0-.036,1.3-.1,2.606-.167,3.908a25.162,25.162,0,0,0-.077,2.79c-1.931-2.623-3.975-5.153-6.049-7.668-.07-.084-.217.033-.148.119,1.282,1.624,2.513,3.29,3.718,4.976-2.351-.548-4.742-.864-7.13-1.208-.122-.019-.17.167-.047.186,2.529.382,5.012,1.016,7.507,1.567.02,0,.032-.009.049-.009q1.437,2.022,2.844,4.061c.384.553.756,1.114,1.134,1.669l-.108-.013c-.259-.036-.518-.076-.778-.106-.553-.067-1.107-.111-1.662-.154-1.152-.09-2.306-.151-3.459-.214-.124-.006-.119.19,0,.193,1.137.026,2.265.112,3.4.234.6.064,1.191.145,1.787.215l.781.093.228.032q.96,1.418,1.922,2.831c1.128,1.669,2.134,3.456,3.338,5.067a.091.091,0,0,0,.156-.1A51.881,51.881,0,0,0,103.887,280.815Z",
    transform: "translate(-89.724 -264.616)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M96.116,269.248c0-.42.009-.84.009-1.259a19.064,19.064,0,0,1,.106-2.642c.019-.14-.19-.16-.19-.022,0,.874-.1,1.746-.137,2.619-.022.436-.022.874-.023,1.31,0,.2,0,.4,0,.6a1.844,1.844,0,0,0,.047.627.088.088,0,0,0,.167,0,1.833,1.833,0,0,0,.026-.579C96.118,269.684,96.116,269.466,96.116,269.248Z",
    transform: "translate(-86.93 -265.231)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M95.853,271.215c-.743-.126-1.5-.166-2.254-.228-.824-.07-1.647-.142-2.467-.249a.1.1,0,1,0-.022.189c1.578.1,3.148.384,4.727.439A.077.077,0,0,0,95.853,271.215Z",
    transform: "translate(-89.138 -262.732)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M98.669,271.154c.058.081.019.317.019.414v.349c0,.25,0,.5,0,.753s0,.5-.006.755a1.562,1.562,0,0,0,.036.659.043.043,0,0,0,.074,0,.648.648,0,0,0,.038-.313c0-.116,0-.233,0-.348l-.006-.755c0-.252,0-.5,0-.755v-.348c0-.106-.041-.329.022-.416C98.957,270.976,98.539,270.973,98.669,271.154Z",
    transform: "translate(-73.237 -256.794)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919",
    transform: "translate(45.09 49.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M103.542,308.944c-4.2-3.154-7.978-7.687-13.63-7.91-4.664-.183-7.933,3.328-9.8,7.239a40.833,40.833,0,0,0-2.287,6.443q-1.265,4.427-2.38,8.9c-1.464,5.86-2.723,11.775-3.741,17.727-.569,3.318-1.1,6.649-1.518,9.991a84.492,84.492,0,0,0-.981,10.228.532.532,0,0,0,1.044.115c.569-2.795.807-5.679,1.218-8.5.414-2.84.845-5.678,1.325-8.507q1.442-8.488,3.347-16.9c1.205-5.285,2.389-10.654,4.095-15.8,1.223-3.69,3.184-8,7.17-9.325,6.065-2.018,11.571,3.115,16.009,6.446C103.507,309.158,103.641,309.018,103.542,308.944Z",
    transform: "translate(-69.201 -292.412)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(15.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M94.368,308.617S90.5,297.556,96.1,295.388c8.4-3.251,30.371,21.5,26.07,59.424,0,0-16.98-9.354-29.518-19.876S76.9,310.67,82.427,307.116,94.368,308.617,94.368,308.617Z",
    transform: "translate(-79.826 -295.102)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917",
    transform: "translate(7.406 11.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M116.136,343.085a29.09,29.09,0,0,0-2.041-3.824c-.717-1.3-1.444-2.592-2.193-3.872-1.46-2.5-2.909-5-4.4-7.472-.243-.4-.494-.8-.737-1.2.033-.147.06-.3.093-.443l.249-1.1c.188-.821.33-1.653.486-2.482.3-1.624.586-3.269,1.024-4.861.032-.118-.164-.156-.19-.033-.346,1.621-.858,3.218-1.338,4.806-.236.781-.487,1.56-.694,2.35-.071.27-.142.542-.212.813-1.806-2.959-3.642-5.9-5.621-8.75a3.973,3.973,0,0,0,.2-1.216c.058-.555.126-1.109.192-1.663.148-1.248.291-2.5.474-3.738a72.852,72.852,0,0,1,1.33-7.266c.031-.121-.158-.153-.189-.033-.6,2.388-1.264,4.776-1.716,7.2-.222,1.188-.433,2.38-.592,3.577-.08.6-.144,1.2-.205,1.8-.019.177-.047.361-.07.544-.609-.859-1.217-1.72-1.855-2.558-1.94-2.552-3.949-5.043-5.977-7.525-.077-.094-.236.015-.157.112a133.713,133.713,0,0,1,9.549,13.944c.555.89,1.1,1.788,1.65,2.681-.185-.025-.368-.047-.545-.068-.71-.09-1.429-.135-2.142-.2q-2.142-.2-4.288-.371c-2.86-.228-5.727-.4-8.582-.71-.122-.013-.157.176-.033.189,2.892.331,5.77.8,8.65,1.205q2.124.3,4.253.573a16.889,16.889,0,0,0,3.274.336q1.684,2.737,3.372,5.474a6.305,6.305,0,0,0-.759-.029c-.477-.007-.954,0-1.429,0q-1.33,0-2.658,0c-1.842,0-3.684.038-5.527.035-.124,0-.1.19.019.192,1.867.023,3.728.118,5.592.215q1.326.068,2.651.16c.442.031.883.067,1.325.095a2.733,2.733,0,0,0,1.166-.045c.954,1.554,1.916,3.1,2.869,4.657q1.317,2.153,2.675,4.281a34.248,34.248,0,0,0,2.879,4.323C116.026,343.268,116.181,343.206,116.136,343.085Z",
    transform: "translate(-83.739 -303.027)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M102.21,309.52a26.805,26.805,0,0,1-.759,3.606q-.469,1.843-1.069,3.65a.12.12,0,1,0,.228.073q.565-1.791,1.008-3.618c.3-1.219.486-2.46.782-3.676C102.43,309.434,102.225,309.4,102.21,309.52Z",
    transform: "translate(-77.903 -300.114)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M96.753,315.1a1.415,1.415,0,0,0-.926-.345c-.534-.076-1.069-.145-1.6-.22-.993-.135-1.991-.244-2.985-.362-2.069-.241-4.141-.444-6.209-.7-.122-.016-.157.174-.033.189,1.951.238,3.892.534,5.842.789.955.125,1.909.26,2.866.372.459.054.92.1,1.38.154a4.854,4.854,0,0,1,1.575.27C96.753,315.291,96.82,315.167,96.753,315.1Z",
    transform: "translate(-84.92 -298.287)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M103.543,326.145c-.976-.083-1.961-.113-2.94-.144l-1.483-.045-.711-.023a4.373,4.373,0,0,1-.926-.054c-.135-.035-.15.214-.007.191a4.135,4.135,0,0,1,.868.028l.769.046,1.482.089c.977.06,1.961.116,2.94.124C103.652,326.356,103.662,326.155,103.543,326.145Z",
    transform: "translate(-79.265 -292.654)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M105.92,324.722c.112-.554.217-1.111.32-1.668l.6-3.279a.1.1,0,0,0-.19-.033l-.72,3.195c-.121.532-.24,1.064-.35,1.6l-.153.739a2.056,2.056,0,0,0-.089.784c.017.089.15.161.212.067A4.013,4.013,0,0,0,105.92,324.722Z",
    transform: "translate(-75.656 -295.473)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921",
    transform: "translate(30.654 111.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920",
    transform: "translate(4.379 11.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M117.2,345.622l-.943,15.674-2.791,46.275H66.017L63.227,361.3l-.943-15.674Z",
    transform: "translate(-62.284 -345.622)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M117.2,345.622l-.943,15.674H63.227l-.943-15.674Z",
    transform: "translate(-62.284 -345.622)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 63.678,
    height: 15.685,
    fill: "#37474f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(151.488 56.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(65.27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 245.478,
    height: 244.973,
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 245.635,
    height: 14.807,
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923",
    transform: "translate(5.516 4.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M170.949,61.931a3.077,3.077,0,1,1-3.077-3.077A3.077,3.077,0,0,1,170.949,61.931Z",
    transform: "translate(-164.794 -58.854)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M179.589,61.931a3.077,3.077,0,1,1-3.077-3.077A3.077,3.077,0,0,1,179.589,61.931Z",
    transform: "translate(-160.87 -58.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M188.23,61.931a3.077,3.077,0,1,1-3.077-3.077A3.076,3.076,0,0,1,188.23,61.931Z",
    transform: "translate(-156.947 -58.854)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 179.493,
    height: 179.493,
    transform: "translate(33.071 39.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930",
    transform: "translate(55.47 58.955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M265.317,226.4V225A62.411,62.411,0,1,0,202.9,162.591h-1.4A63.809,63.809,0,1,1,265.317,226.4Z",
    transform: "translate(-198.08 -95.354)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924",
    transform: "translate(0 63.111)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M206.482,143.736a3.426,3.426,0,1,1-3.426-3.426A3.426,3.426,0,0,1,206.482,143.736Z",
    transform: "translate(-198.932 -139.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M203.275,148.079a4.125,4.125,0,1,1,4.125-4.125A4.13,4.13,0,0,1,203.275,148.079Zm0-6.851A2.726,2.726,0,1,0,206,143.954,2.729,2.729,0,0,0,203.275,141.228Z",
    transform: "translate(-199.15 -139.829)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M236.853,135.934a7.439,7.439,0,1,1-7.439-7.439A7.438,7.438,0,0,1,236.853,135.934Z",
    transform: "translate(-188.787 -81.863)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 7.439,
    cy: 7.439,
    r: 7.439,
    transform: "translate(86.404 46.632)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925",
    transform: "translate(126.22 63.111)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 3.426,
    cy: 3.426,
    r: 3.426,
    transform: "translate(0.7 0.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M290.083,148.079a4.125,4.125,0,1,1,4.126-4.125A4.129,4.129,0,0,1,290.083,148.079Zm0-6.851a2.726,2.726,0,1,0,2.726,2.726A2.729,2.729,0,0,0,290.083,141.228Z",
    transform: "translate(-285.958 -139.829)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926",
    transform: "translate(63.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M249.886,100.332a3.426,3.426,0,1,1-3.426-3.426A3.425,3.425,0,0,1,249.886,100.332Z",
    transform: "translate(-242.336 -96.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M246.68,104.676a4.126,4.126,0,1,1,4.125-4.126A4.131,4.131,0,0,1,246.68,104.676Zm0-6.853a2.726,2.726,0,1,0,2.726,2.726A2.73,2.73,0,0,0,246.68,97.823Z",
    transform: "translate(-242.554 -96.424)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M249.886,187.121a3.426,3.426,0,1,1-3.426-3.426A3.425,3.425,0,0,1,249.886,187.121Z",
    transform: "translate(-179.226 -56.802)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929",
    transform: "translate(65.192 127.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(0 2.616)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M259.657,194.251a39.067,39.067,0,0,1,2.718,17.351L256,214.717a39.056,39.056,0,0,1-12.015-12.811c4.756-6.859.925-15.135.925-15.135l.662-.323,6.337,12.974a2.224,2.224,0,1,0,.917-.448L246.49,186l.66-.323S251.323,193.786,259.657,194.251Z",
    transform: "translate(-243.986 -185.677)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 10.481,
    height: 4.412,
    transform: "translate(10.114 29.006) rotate(-26.034)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928",
    transform: "translate(23.232 28.218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 0.814,
    height: 7.851,
    transform: "translate(3.518)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 7.851,
    height: 0.814,
    transform: "translate(0 3.518)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 7.851,
    height: 0.814,
    transform: "translate(0.862 6.413) rotate(-45)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 0.814,
    height: 7.851,
    transform: "translate(0.862 1.437) rotate(-45)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M270.307,198.994c-6.185-.156-8.263-4.195-10.1-7.759-1.013-1.972-1.972-3.833-3.52-4.736-4.941-2.882-9.608,1.32-9.8,1.5l-1.105-1.2c.057-.052,5.739-5.207,11.73-1.713,1.959,1.143,3.021,3.21,4.148,5.4,1.783,3.468,3.468,6.744,8.688,6.875Z",
    transform: "translate(-243.171 -183.878)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M263.73,132.454a13.975,13.975,0,0,1-27.951,0Z",
    transform: "translate(-182.519 -80.066)",
    fill: "#ffc727"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(0 51.501)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 42.811,
    height: 160.985,
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932",
    transform: "translate(2.029 1.794)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 0.35,
    height: 3.741,
    transform: "translate(0 0.247) rotate(-44.998)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 3.741,
    height: 0.35,
    transform: "translate(0 2.646) rotate(-45)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(37.459 1.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 0.35,
    height: 2.221,
    transform: "translate(0 1.57) rotate(-45.013)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 2.221,
    height: 0.35,
    transform: "translate(0 1.57) rotate(-45)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(1.732 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 0.35,
    height: 2.22,
    transform: "translate(0 1.57) rotate(-45)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 2.22,
    height: 0.35,
    transform: "translate(0 1.57) rotate(-45)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M125.844,114.774l-1.839-4.443-3.286,2.55V98.6l9.985,10.088-4.179.624,1.832,4.423Zm-1.543-5.559,1.921,4.646,1.221-.506-1.908-4.6,3.7-.551-7.818-7.9v11.152Z",
    transform: "translate(-114.019 -87.982)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M141.461,108.765l1.869,4.514-1.867.773-1.88-4.545L136.5,111.9V99.185l8.9,8.993Z",
    transform: "translate(-106.854 -87.717)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(5.467 34.826)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 14.139,
    height: 1.05,
    transform: "matrix(0.615, -0.789, 0.789, 0.615, 1.275, 14.84)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M125.072,119.574l-2.125.393-.475,2.24-.475-2.24-2.125-.394,2.116-.517.484-2.116.484,2.116Z",
    transform: "translate(-119.871 -114.482)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M127.643,116.8l-1.247.231-.279,1.315-.279-1.315-1.247-.231,1.242-.3.284-1.242.284,1.242Z",
    transform: "translate(-117.728 -115.249)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M128.245,121.443l-.711.131-.159.749-.159-.749-.711-.132.708-.173.162-.708.162.708Z",
    transform: "translate(-116.859 -112.837)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937",
    transform: "translate(27.385 78.422)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 14.139,
    height: 1.05,
    transform: "matrix(0.615, -0.789, 0.789, 0.615, 0, 11.154)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(24.751 34.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M141.461,126.184l1.869,4.514-1.867.773-1.88-4.544L136.5,129.32V116.6l8.9,8.993Z",
    transform: "translate(-131.605 -114.68)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M137.162,125.048c-1.834,0-3.266-.635-3.759-1.6-.737-1.448-.18-4.5,4.372-6.987,3.625-1.98,7.231-1.163,8.122.266a2.938,2.938,0,0,1,.141,2.425,8.8,8.8,0,0,1-5,5.038h0A9.685,9.685,0,0,1,137.162,125.048Zm5.063-9.076a8.689,8.689,0,0,0-4.113,1.1c-4.087,2.23-4.675,4.9-4.084,6.057s3.431,1.874,6.726.42h0a8.214,8.214,0,0,0,4.618-4.6,2.277,2.277,0,0,0-.068-1.85A3.7,3.7,0,0,0,142.225,115.972Z",
    transform: "translate(-133.133 -115.281)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M135.068,123.672a1.629,1.629,0,0,1-1.338-.67h0a1.5,1.5,0,0,1-.2-1.61,2.1,2.1,0,0,1,1.813-1.083,1.569,1.569,0,0,1,1.453.822,1.635,1.635,0,0,1-.638,2.219A2.042,2.042,0,0,1,135.068,123.672Zm-.776-1.089a1.082,1.082,0,0,0,1.487.176.943.943,0,0,0,.4-1.3.859.859,0,0,0-.823-.451,1.42,1.42,0,0,0-1.2.692.806.806,0,0,0,.137.883Z",
    transform: "translate(-133.022 -112.998)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M136.27,124.791l-.419-.561c.209-.156.452-.391.42-.625-.055-.41-.83-.84-1.2-.984l.254-.651c.154.06,1.508.614,1.634,1.541A1.381,1.381,0,0,1,136.27,124.791Z",
    transform: "translate(-132.251 -112.244)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(5.227 57.63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M121.5,135.7a17.331,17.331,0,0,1,6.886-3.641l2.225,2.225a17.332,17.332,0,0,1-3.641,6.885c-3.562-1.006-6.482,1.794-6.482,1.794l-.23-.231,4.528-4.528a.986.986,0,1,0-.32-.32l-4.528,4.528-.231-.231S122.506,139.266,121.5,135.7Z",
    transform: "translate(-119.706 -130.42)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 4.648,
    height: 1.956,
    transform: "translate(11.163 4.67) rotate(-135)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 17.135,
    height: 16.005,
    transform: "translate(22.798 55.443)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(23.613 57.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(3.6 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M136.621,135.7a17.317,17.317,0,0,1,6.885-3.641l2.225,2.225a17.331,17.331,0,0,1-3.641,6.885c-3.562-1.006-6.481,1.794-6.481,1.794l-.231-.231,4.528-4.528a.986.986,0,1,0-.32-.32l-4.528,4.528-.231-.231S137.627,139.266,136.621,135.7Z",
    transform: "translate(-134.827 -130.42)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 4.648,
    height: 1.956,
    transform: "translate(11.164 4.67) rotate(-135)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M136.182,142.713a2.722,2.722,0,0,1-2.39-1.182c-.491-.781-.8-2.289.521-5.041a2.592,2.592,0,0,0,.205-2.39,3.139,3.139,0,0,0-2.167-1.227l.079-.7a3.816,3.816,0,0,1,2.7,1.583,3.234,3.234,0,0,1-.186,3.033c-1.182,2.463-.957,3.734-.56,4.363a2.062,2.062,0,0,0,1.8.856Z",
    transform: "translate(-132.351 -130.368)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(5.649 77.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M130.033,144.822v2.856h-.951a.383.383,0,0,1-.4-.317c-.016-.1-.049-.317-.083-.685h-2.456v8.569c.2.033.368.067.484.083s.2.051.252.051a.59.59,0,0,1,.1.016.494.494,0,0,1,.435.519v.984h-4.776v-.984a.48.48,0,0,1,.417-.519.648.648,0,0,1,.1-.016c.049,0,.134-.033.25-.051s.284-.049.484-.083V146.66h-2.456c-.032.368-.065.6-.083.7a.365.365,0,0,1-.384.317H120v-2.856h10.037Z",
    transform: "translate(-119.996 -144.822)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M131.889,172.953H119.635V160.7h12.254ZM120.683,171.9H130.84V161.75H120.683Z",
    transform: "translate(-114.511 -59.788)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(23.515 140.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M144.653,197.212H134.074v-9.471h10.579Zm-9.53-1.05h8.48v-7.373h-8.48Z",
    transform: "translate(-131.47 -187.741)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M139.656,198.247h-7.373v-6.636h7.373Zm-6.324-1.048h5.274v-4.538h-5.274Z",
    transform: "translate(-132.283 -185.984)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 3.771,
    height: 0.7,
    transform: "translate(8.185 4.615) rotate(-45)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M140.9,190.995h-.7v-1.4h-1.339v-.7H140.9Z",
    transform: "translate(-129.296 -187.216)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(25.018 96.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M145.577,174.215h-12.26v-12.26h5.722a4.648,4.648,0,0,1,9.253.622,4.686,4.686,0,0,1-2.715,4.234Zm-11.21-1.05h10.161V166.1l.343-.128a3.6,3.6,0,0,0-1.226-6.989,3.579,3.579,0,0,0-3.6,3.513l-.013.512h-5.668Z",
    transform: "translate(-133.317 -157.93)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M139.766,163.073c-1.828-.3-2.084,1.621-2.113,2.373a2.117,2.117,0,0,1-1.476,1.621s2.837.782,4.254-.666A1.907,1.907,0,0,0,139.766,163.073Z",
    transform: "translate(-132.018 -155.61)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M144.923,159.019l-4.582,6.475a1.978,1.978,0,0,0-1.421-1.086,2.912,2.912,0,0,0-.32-.028l3.8-5.361Z",
    transform: "translate(-130.918 -157.436)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(5.338 121.316)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 4.554,
    height: 9.281,
    transform: "translate(6.845 1.931) rotate(45)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 4.554,
    height: 1.968,
    transform: "translate(8.776) rotate(45)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M119.782,184.052l.256-3.424.7.052-.2,2.613,2.613-.2.052.7Z",
    transform: "translate(-119.782 -172.056)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948",
    transform: "translate(23.586 122.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M140.936,180.777a2.47,2.47,0,1,1,2.469-2.47A2.475,2.475,0,0,1,140.936,180.777Zm0-3.891a1.421,1.421,0,1,0,1.421,1.421A1.424,1.424,0,0,0,140.936,176.886Z",
    transform: "translate(-129.582 -175.836)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M132.356,183.561l9.69-5.336,1.665.942s-7.056,4.311-8.307,4.769A4.875,4.875,0,0,1,132.356,183.561Z",
    transform: "translate(-132.356 -174.751)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(0 1.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M140.911,184.556a2.47,2.47,0,1,1,2.47-2.47A2.474,2.474,0,0,1,140.911,184.556Zm0-3.891a1.421,1.421,0,1,0,1.421,1.421A1.424,1.424,0,0,0,140.911,180.665Z",
    transform: "translate(-129.558 -175.234)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M132.332,177.116l9.69,5.335,1.663-.942s-7.055-4.311-8.305-4.769A4.872,4.872,0,0,0,132.332,177.116Z",
    transform: "translate(-132.332 -176.603)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(5.193 141.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M119.682,197.921v-9.088l5.8,4.544Zm1.05-6.931v4.775l3.046-2.387Z",
    transform: "translate(-119.682 -188.417)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M129.758,188.926v8.819l-5.612-4.41Z",
    transform: "translate(-117.655 -188.375)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M124.161,198.343h-.35v-1.4h.35Zm0-2.8h-.35v-1.4h.35Zm0-2.8h-.35v-1.4h.35Zm0-2.8h-.35v-1.4h.35Z",
    transform: "translate(-117.807 -188.547)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(316.779 11.619)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 88.167,
    height: 52.309,
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951",
    transform: "translate(2.029 1.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M338.017,68l-2.646-2.646.249-.247,2.645,2.646Z",
    transform: "translate(-335.371 -65.103)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M335.62,68l-.249-.247,2.646-2.646.249.247Z",
    transform: "translate(-335.371 -65.103)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954",
    transform: "translate(82.617 1.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 0.35,
    height: 2.221,
    transform: "translate(0 1.57) rotate(-44.989)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 2.221,
    height: 0.35,
    transform: "translate(0 1.57) rotate(-44.998)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953",
    transform: "translate(1.731 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 0.35,
    height: 2.221,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 1.57)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 2.221,
    height: 0.35,
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0, 1.571)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 0.35,
    height: 34.372,
    transform: "translate(15.582 8.325)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 0.35,
    height: 34.372,
    transform: "translate(28.261 8.325)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955",
    transform: "translate(5.634 11.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M341.524,71.773a4.319,4.319,0,0,0-3.673,2.081,4.534,4.534,0,0,0,3.673,2.092,4.694,4.694,0,0,0,3.729-2.092A4.5,4.5,0,0,0,341.524,71.773Zm0,3.792a1.706,1.706,0,1,1,1.7-1.7A1.7,1.7,0,0,1,341.524,75.565Z",
    transform: "translate(-337.851 -71.773)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M342.1,73.619a1.318,1.318,0,1,1-1.317-1.317A1.318,1.318,0,0,1,342.1,73.619Z",
    transform: "translate(-337.118 -71.533)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(5.634 23.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M341.524,80a4.319,4.319,0,0,0-3.673,2.079,4.534,4.534,0,0,0,3.673,2.092,4.694,4.694,0,0,0,3.729-2.092A4.5,4.5,0,0,0,341.524,80Zm0,3.792a1.706,1.706,0,1,1,1.7-1.7A1.7,1.7,0,0,1,341.524,83.789Z",
    transform: "translate(-337.851 -79.997)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M342.1,81.842a1.318,1.318,0,1,1-1.317-1.317A1.318,1.318,0,0,1,342.1,81.842Z",
    transform: "translate(-337.118 -79.757)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957",
    transform: "translate(5.634 34.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M341.524,87.853a4.319,4.319,0,0,0-3.673,2.079,4.533,4.533,0,0,0,3.673,2.094,4.694,4.694,0,0,0,3.729-2.094A4.5,4.5,0,0,0,341.524,87.853Zm0,3.792a1.706,1.706,0,1,1,1.7-1.7A1.7,1.7,0,0,1,341.524,91.645Z",
    transform: "translate(-337.851 -87.853)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M342.1,89.7a1.318,1.318,0,1,1-1.317-1.319A1.318,1.318,0,0,1,342.1,89.7Z",
    transform: "translate(-337.118 -87.613)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 80.882,
    height: 0.35,
    transform: "translate(3.643 19.624)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 80.882,
    height: 0.35,
    transform: "translate(3.643 31.099)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958",
    transform: "translate(37.778 10.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M360.176,76.743h-.016a.2.2,0,0,1-.2-.2V71.1a.205.205,0,0,1,.41,0v5.234h2.8a.2.2,0,1,1,0,.409Z",
    transform: "translate(-359.958 -70.899)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M366.7,72.306v3.689a.2.2,0,1,1-.4,0v-.609a1.912,1.912,0,0,1-1.537.81,2.048,2.048,0,0,1,0-4.09,1.9,1.9,0,0,1,1.537.8v-.6a.2.2,0,1,1,.4,0Zm-.4,1.844a1.54,1.54,0,1,0-1.537,1.646A1.6,1.6,0,0,0,366.3,74.149Z",
    transform: "translate(-358.657 -70.351)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M366.625,72.3a.194.194,0,0,1,.192-.192.2.2,0,0,1,.209.192v2.22a1.252,1.252,0,0,0,1.252,1.261,1.267,1.267,0,0,0,1.269-1.261V72.3a.146.146,0,0,1,.032-.1c0-.009.01-.016.01-.025s.007-.009.016-.009a.15.15,0,0,1,.076-.051h.016c.009,0,.016-.007.025-.007h.051a.413.413,0,0,1,.1.042.183.183,0,0,1,.051.067.166.166,0,0,1,.025.083v3.573A1.926,1.926,0,0,1,368,77.79a2.048,2.048,0,0,1-.843-.192.207.207,0,0,1-.084-.268.216.216,0,0,1,.259-.1,1.515,1.515,0,0,0,.669.158,1.536,1.536,0,0,0,1.544-1.519V75.6a1.692,1.692,0,0,1-1.269.586,1.672,1.672,0,0,1-1.653-1.671Z",
    transform: "translate(-356.931 -70.351)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M369.863,74.158a1.98,1.98,0,0,1,3.958-.15v.033a.189.189,0,0,1-.2.183h-3.356a1.608,1.608,0,0,0,1.585,1.57,1.544,1.544,0,0,0,1.32-.743.193.193,0,0,1,.266-.067.214.214,0,0,1,.068.284,1.955,1.955,0,0,1-1.655.926A2.013,2.013,0,0,1,369.863,74.158Zm.426-.326h3.1a1.579,1.579,0,0,0-1.537-1.328A1.6,1.6,0,0,0,370.289,73.832Z",
    transform: "translate(-355.461 -70.351)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M373.44,72.311a.2.2,0,0,1,.209-.2.2.2,0,0,1,.19.2v.9a.823.823,0,0,1,.06-.1,1.974,1.974,0,0,1,1.636-1,.2.2,0,0,1,.2.2.2.2,0,0,1-.2.2,1.475,1.475,0,0,0-1.185.669,3.631,3.631,0,0,0-.493.951.121.121,0,0,0-.017.067v1.794a.2.2,0,0,1-.19.2.2.2,0,0,1-.209-.2Z",
    transform: "translate(-353.837 -70.349)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M378.472,71.482l-.826.486a.211.211,0,0,1-.1.033.2.2,0,0,1-.174-.1.194.194,0,0,1,.074-.276l1.128-.685a.209.209,0,0,1,.273.076.23.23,0,0,1,.026.15v5.368a.2.2,0,0,1-.2.2.2.2,0,0,1-.2-.2Z",
    transform: "translate(-352.065 -70.891)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959",
    transform: "translate(37.778 22.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M360.176,85.024h-.016a.2.2,0,0,1-.2-.2V79.379a.205.205,0,0,1,.41,0v5.234h2.8a.208.208,0,0,1,.209.209.2.2,0,0,1-.209.2Z",
    transform: "translate(-359.958 -79.18)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M366.7,80.585v3.69a.2.2,0,1,1-.4,0v-.609a1.912,1.912,0,0,1-1.537.81,2.048,2.048,0,0,1,0-4.09,1.9,1.9,0,0,1,1.537.8v-.6a.2.2,0,0,1,.4,0Zm-.4,1.845a1.54,1.54,0,1,0-1.537,1.644A1.6,1.6,0,0,0,366.3,82.43Z",
    transform: "translate(-358.657 -78.632)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M366.625,80.576a.193.193,0,0,1,.192-.19.2.2,0,0,1,.209.19V82.8a1.252,1.252,0,0,0,1.252,1.261,1.267,1.267,0,0,0,1.269-1.261V80.576a.148.148,0,0,1,.032-.1c0-.007.01-.016.01-.025s.007-.009.016-.009a.147.147,0,0,1,.076-.049h.016c.009,0,.016-.007.025-.007h.051a.407.407,0,0,1,.1.041.2.2,0,0,1,.051.067.166.166,0,0,1,.025.083V84.15A1.927,1.927,0,0,1,368,86.071a2.027,2.027,0,0,1-.843-.193.205.205,0,0,1-.084-.266.214.214,0,0,1,.259-.1,1.514,1.514,0,0,0,.669.158,1.536,1.536,0,0,0,1.544-1.519v-.268a1.7,1.7,0,0,1-1.269.585,1.671,1.671,0,0,1-1.653-1.669Z",
    transform: "translate(-356.931 -78.632)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M369.863,82.439a1.98,1.98,0,0,1,3.958-.15v.033a.189.189,0,0,1-.2.183h-3.356a1.608,1.608,0,0,0,1.585,1.569,1.541,1.541,0,0,0,1.32-.743.194.194,0,0,1,.266-.067.215.215,0,0,1,.068.285,1.955,1.955,0,0,1-1.655.926A2.014,2.014,0,0,1,369.863,82.439Zm.426-.326h3.1a1.579,1.579,0,0,0-1.537-1.328A1.6,1.6,0,0,0,370.289,82.113Z",
    transform: "translate(-355.461 -78.632)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M373.44,80.592a.2.2,0,0,1,.209-.2.2.2,0,0,1,.19.2v.9a.724.724,0,0,1,.06-.1,1.971,1.971,0,0,1,1.636-1,.2.2,0,0,1,.2.2.2.2,0,0,1-.2.2,1.474,1.474,0,0,0-1.185.667,3.656,3.656,0,0,0-.493.952.121.121,0,0,0-.017.067v1.794a.2.2,0,0,1-.19.2.2.2,0,0,1-.209-.2Z",
    transform: "translate(-353.837 -78.63)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M377.479,84.665l2.731-2.463a1.515,1.515,0,0,0,.5-1.118,1.508,1.508,0,0,0-1.5-1.495,1.521,1.521,0,0,0-1.019.384l-.284.259a.2.2,0,1,1-.275-.292l.284-.266a1.95,1.95,0,0,1,1.294-.493,1.916,1.916,0,0,1,1.9,1.9,1.92,1.92,0,0,1-.625,1.419l-2.337,2.111h2.763a.206.206,0,0,1,.2.209.2.2,0,0,1-.2.2h-3.289a.182.182,0,0,1-.15-.06A.218.218,0,0,1,377.479,84.665Z",
    transform: "translate(-352.032 -79.18)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(37.778 34.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M360.176,93.3h-.016a.2.2,0,0,1-.2-.2V87.661a.205.205,0,0,1,.41,0V92.9h2.8a.2.2,0,1,1,0,.409Z",
    transform: "translate(-359.958 -87.46)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M366.7,88.867v3.69a.2.2,0,0,1-.4,0v-.611a1.912,1.912,0,0,1-1.537.81,2.048,2.048,0,0,1,0-4.09,1.9,1.9,0,0,1,1.537.8v-.6a.2.2,0,1,1,.4,0Zm-.4,1.844a1.54,1.54,0,1,0-1.537,1.646A1.6,1.6,0,0,0,366.3,90.71Z",
    transform: "translate(-358.657 -86.912)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M366.625,88.858a.194.194,0,0,1,.192-.192.2.2,0,0,1,.209.192v2.22a1.252,1.252,0,0,0,1.252,1.261,1.267,1.267,0,0,0,1.269-1.261v-2.22a.146.146,0,0,1,.032-.1c0-.009.01-.016.01-.025s.007-.009.016-.009a.139.139,0,0,1,.076-.049h.016c.009,0,.016-.009.025-.009h.051a.481.481,0,0,1,.1.042.184.184,0,0,1,.051.067.166.166,0,0,1,.025.083V92.43A1.926,1.926,0,0,1,368,94.351a2.048,2.048,0,0,1-.843-.192.207.207,0,0,1-.084-.268.216.216,0,0,1,.259-.1,1.514,1.514,0,0,0,.669.158,1.535,1.535,0,0,0,1.544-1.519v-.268a1.692,1.692,0,0,1-1.269.586,1.672,1.672,0,0,1-1.653-1.671Z",
    transform: "translate(-356.931 -86.912)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M369.863,90.719a1.98,1.98,0,0,1,3.958-.15V90.6a.189.189,0,0,1-.2.183h-3.356a1.608,1.608,0,0,0,1.585,1.57,1.544,1.544,0,0,0,1.32-.743.193.193,0,0,1,.266-.067.214.214,0,0,1,.068.284,1.955,1.955,0,0,1-1.655.926A2.013,2.013,0,0,1,369.863,90.719Zm.426-.326h3.1a1.579,1.579,0,0,0-1.537-1.327A1.6,1.6,0,0,0,370.289,90.393Z",
    transform: "translate(-355.461 -86.912)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M373.44,88.871a.2.2,0,0,1,.209-.2.2.2,0,0,1,.19.2v.9a.835.835,0,0,1,.06-.1,1.973,1.973,0,0,1,1.636-1,.2.2,0,0,1,.2.2.2.2,0,0,1-.2.2,1.474,1.474,0,0,0-1.185.667,3.653,3.653,0,0,0-.493.951.124.124,0,0,0-.017.067v1.8a.2.2,0,0,1-.19.2.2.2,0,0,1-.209-.2Z",
    transform: "translate(-353.837 -86.91)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M380.947,87.828l-1.511,1.553a1.982,1.982,0,1,1-1.8,3.34.207.207,0,0,1,.292-.294,1.571,1.571,0,0,0,1.1.452,1.589,1.589,0,0,0,1.111-.452,1.562,1.562,0,0,0,.459-1.109,1.569,1.569,0,0,0-1.562-1.562.221.221,0,0,1-.167-.083h-.009a.213.213,0,0,1,0-.3l1.453-1.495h-2.236a.209.209,0,1,1,0-.417h2.729a.206.206,0,0,1,.208.209.266.266,0,0,1-.067.158Z",
    transform: "translate(-351.961 -87.46)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 2.618,
    height: 9.924,
    transform: "translate(29.482 20.574)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 2.618,
    height: 9.924,
    transform: "translate(29.482 31.997)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 2.618,
    height: 9.924,
    transform: "translate(29.482 8.617)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 15.37,
    height: 0.35,
    transform: "translate(3.643 48.089)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(19.464 9.717)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 5.322,
    height: 4.471,
    transform: "translate(0 3.252)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M351.853,74.3h-.619V73.121c0-1.294-.458-1.95-1.36-1.95-1.464,0-1.48,1.73-1.48,1.8V74.3h-.619V72.974a2.2,2.2,0,0,1,2.1-2.422c1.277,0,1.979.913,1.979,2.569Z",
    transform: "translate(-347.175 -70.552)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M388.084,76.778a2.721,2.721,0,1,1,2.72-2.72A2.723,2.723,0,0,1,388.084,76.778Zm0-5.092a2.371,2.371,0,1,0,2.372,2.371A2.374,2.374,0,0,0,388.084,71.686Z",
    transform: "translate(-310.645 -60.479)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M388.084,85a2.721,2.721,0,1,1,2.72-2.722A2.724,2.724,0,0,1,388.084,85Zm0-5.092a2.371,2.371,0,1,0,2.372,2.37A2.372,2.372,0,0,0,388.084,79.91Z",
    transform: "translate(-310.645 -56.745)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M388.084,93.225a2.72,2.72,0,1,1,2.72-2.72A2.723,2.723,0,0,1,388.084,93.225Zm0-5.092a2.371,2.371,0,1,0,2.372,2.371A2.374,2.374,0,0,0,388.084,88.133Z",
    transform: "translate(-310.645 -53.011)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973",
    transform: "translate(355.519 253.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966",
    transform: "translate(3.431 174.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M292.132,311.43l-3.761,22.549L262.9,471.541h-4.106l18.523-137.561,2.737-22.549Z",
    transform: "translate(-258.793 -311.43)",
    fill: "#c7c7c7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M274.27,311.43h12.078l-3.761,22.549H271.533Z",
    transform: "translate(-253.01 -311.43)",
    fill: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969",
    transform: "translate(83.423 174.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M347.147,471.541h-4.106L317.568,333.979l-3.76-22.549h12.078l2.737,22.549Z",
    transform: "translate(-313.808 -311.43)",
    fill: "#c7c7c7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M325.886,311.43l2.737,22.549H317.568l-3.76-22.549Z",
    transform: "translate(-313.808 -311.43)",
    fill: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972",
    transform: "translate(159.827 174.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M399.694,471.541h-4.106L370.115,333.979l-3.76-22.549h12.079l2.737,22.549Z",
    transform: "translate(-366.355 -311.43)",
    fill: "#c7c7c7"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M381.171,333.979H370.115l-3.76-22.549h12.079Z",
    transform: "translate(-366.355 -311.43)",
    fill: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M443.087,376.6H256.434V356.933h69.874l23.483-165.709h86.18Z",
    transform: "translate(-256.434 -191.224)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M432.213,305.191H256.434v19.667H432.913Z",
    transform: "translate(-256.434 -139.481)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M390.053,376.6H379.878l-6.632-185.377h9.69Z",
    transform: "translate(-203.399 -191.224)",
    fill: "#dbdbdb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(201.074 174.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990",
    transform: "translate(0 150.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(116.87 2.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(31.482 168.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M254.98,476.2c3.615.342,102-23.2,105.1-26.395.378-.355-1.565-9.3-4.419-21.492l-.057-.24c-1.781-7.731-30.514-70.246-30.514-70.246l-63.767,17.851,29.038,58s-12,8.679-22.28,16.919c-.012.017-.025.02-.022.035-6.353,5.06-11.827,9.605-12.989,11.077C252.065,465.555,251.372,475.893,254.98,476.2Z",
    transform: "translate(-252.11 -357.831)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M254.985,462.2c3.606.343,101.992-23.2,105.1-26.389.377-.362-1.573-9.294-4.425-21.5l-.058-.231c-.654-2.88-5.08-13.387-10.35-25.428-10.494,2.834-48.112,13.037-61.775,17.28l6.876,13.746s-11.993,8.686-22.278,16.92c0,.015-.015.015-.015.029-6.351,5.06-11.834,9.613-12.99,11.075C252.064,451.564,251.366,461.9,254.985,462.2Z",
    transform: "translate(-252.111 -343.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(0 58.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M254.792,458.3c3.718.318,102.173-23.494,105.355-26.774,1.213-1.239-.982-16.776-6.39-33.237L290.3,413.721s-32.391,25.694-35.494,29.668C251.725,447.355,251.074,457.984,254.792,458.3Z",
    transform: "translate(-252.243 -398.292)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975",
    transform: "translate(2.777 0.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(0 16.834)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M254.384,444.017c16.406-4.4,82.994-20.583,99.545-23.681.135-.026.157.064.025.1-16.166,4.712-82.882,20.359-99.505,23.849C254.1,444.362,254.038,444.11,254.384,444.017Z",
    transform: "translate(-254.153 -405.492)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M257.8,425.965a13.642,13.642,0,0,1,10.847,1.643,13.218,13.218,0,0,1,5.82,7.92c.02.1-.16.145-.2.047-2.505-6.23-9.752-10.482-16.419-9.4A.107.107,0,0,1,257.8,425.965Z",
    transform: "translate(-252.534 -403.149)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M275.231,411.184c6.584-1.69,14.806-1.21,20.218,3.2.209.17-.036.465-.256.413a93.944,93.944,0,0,0-19.879-2.773A.427.427,0,0,1,275.231,411.184Z",
    transform: "translate(-244.729 -410.054)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M272.055,413.4c6.584-1.69,14.806-1.211,20.218,3.2.209.172-.036.467-.257.413a93.926,93.926,0,0,0-19.878-2.771A.427.427,0,0,1,272.055,413.4Z",
    transform: "translate(-246.171 -409.048)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M268.878,415.615c6.584-1.69,14.806-1.21,20.218,3.2.209.17-.036.465-.257.412a94,94,0,0,0-19.878-2.771A.427.427,0,0,1,268.878,415.615Z",
    transform: "translate(-247.613 -408.042)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M265.7,417.831c6.584-1.69,14.8-1.21,20.217,3.2.211.172-.035.467-.256.413a93.926,93.926,0,0,0-19.878-2.771A.427.427,0,0,1,265.7,417.831Z",
    transform: "translate(-249.055 -407.036)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M318.642,410.31c7.417-1.771,10.182,9.752,2.752,11.526S311.214,412.083,318.642,410.31Z",
    transform: "translate(-226.862 -410.125)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M270.476,410.166c4.676,3.737,10.808,5.319,16.3,7.434a.829.829,0,0,0,1.059-.82.18.18,0,0,0,.161-.24,35.666,35.666,0,0,0-10.088-15.44c-2.758-2.38-7.626-4.071-10.3-.49C265.078,404,267.744,407.983,270.476,410.166Zm-1.63-5.4c-1.082-7.346,6.738-3.394,8.7-1.557a38.321,38.321,0,0,1,3.491,3.872,107.024,107.024,0,0,1,6.089,8.887c-2.633-1.2-5.346-2.172-8.02-3.279C275.918,411.371,269.442,408.818,268.846,404.767Z",
    transform: "translate(-248.505 -398.548)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M304.261,405.193c-1.562-4.188-6.709-3.93-10.024-2.419a35.65,35.65,0,0,0-14.015,11.988.179.179,0,0,0,.087.275.83.83,0,0,0,.787,1.085c5.863-.49,12.192-.288,17.73-2.562C302.058,412.23,305.737,409.154,304.261,405.193Zm-14.428,8.366c-2.879.311-5.754.48-8.619.9a106.958,106.958,0,0,1,8.339-6.822,38.28,38.28,0,0,1,4.438-2.736c2.4-1.211,11.013-2.811,7.914,3.936C300.2,412.555,293.263,413.189,289.833,413.559Z",
    transform: "translate(-242.333 -397.086)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M293.1,480.924l68.318-20.49S305.11,343.08,306.886,337.11c1.186-3.987,85.618-4.263,110.361-26.482,25.612-23,5.671-68.171,5.671-68.171l-70.985-.365s1.218,14.816-1.493,17.12c-1.788,1.537-98.842,10.076-117.428,45.761C216.144,337.362,293.1,480.924,293.1,480.924Z",
    transform: "translate(-230.59 -242.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M306.884,337.108c-.307,1.006,1.064,5.224,3.565,11.53l-51.02,62.684c-18.2-41.476-35.3-89.308-26.419-106.345,18.594-35.683,115.635-44.227,117.438-45.761,2.7-2.3,1.482-17.127,1.482-17.127l45.057.233L322.1,334.3C313.086,335.3,307.191,336.07,306.884,337.108Z",
    transform: "translate(-230.591 -242.09)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(57.011 6.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(3.698 200.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M272.453,401.837a42.446,42.446,0,0,1,5.57-2.07c1.97-.67,3.94-1.346,5.922-1.983,3.9-1.255,7.811-2.454,11.751-3.568,7.935-2.244,15.882-4.443,23.874-6.475,4.166-1.059,13.09-3.369,13.644-3.285.266.042.326.487.087.571-7.721,2.764-15.564,5.131-23.4,7.523s-15.67,4.746-23.606,6.748c-2.2.555-4.409,1.048-6.613,1.576a49.654,49.654,0,0,1-7.023,1.5C272.428,402.4,272.2,401.963,272.453,401.837Z",
    transform: "translate(-272.344 -384.453)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M401.3,253.923c-.218-2.37-.483-4.734-.752-7.1-.032-.273-.461-.27-.433.009.947,9.6,1.919,19.427.153,28.993A41.345,41.345,0,0,1,387.592,298.8c-14.084,13.133-33.775,17-52.124,20.122-10.51,1.788-21.082,3.162-31.69,4.2q-7.795.766-15.613,1.25c-5.165.321-10.34.372-15.5.659-1.631.09-3.087.836-2.832,2.7a13.01,13.01,0,0,0,1.242,3.26c.55,1.256,1.107,2.51,1.66,3.764q3.108,7.032,6.252,14.049,6.482,14.458,13.149,28.833,13.232,28.541,27.455,56.615,1.762,3.483,3.538,6.963c.077.151.3.013.224-.138q-13.583-28.425-26.835-57.012c-4.378-9.46-8.768-18.915-13.1-28.4q-3.248-7.11-6.457-14.238-1.605-3.564-3.2-7.13l-1.592-3.57c-.441-.989-2.047-3.359-.939-4.284.74-.618,2.278-.406,3.165-.43,1.374-.041,2.747-.092,4.119-.137q3.913-.131,7.823-.323,7.921-.4,15.826-1.083c10.318-.894,20.6-2.2,30.829-3.847,18.233-2.933,38.062-6.242,52.654-18.482a43.859,43.859,0,0,0,14-20.411C402.424,272.764,402.158,263.172,401.3,253.923Z",
    transform: "translate(-269.801 -246.62)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(0 131.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M151.151,398.688c2.568,2.568,93.364,47.18,97.787,46.694.519-.032,4.726-8.159,10.3-19.372l.111-.221c3.557-7.091,35.857-66.747,35.857-66.747l-56.49-28.6-33.2,58.054s-14.774-.965-27.951-1.178c-.02.007-.032,0-.039.013-8.119-.153-15.235-.144-17.069.249C155.7,388.625,148.571,396.146,151.151,398.688Z",
    transform: "translate(-150.036 -330.444)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M151.15,385.671c2.569,2.566,93.365,47.184,97.8,46.7.513-.025,4.721-8.158,10.3-19.363l.111-.221c.247-.491.5-1,.769-1.495q.264-.55.564-1.077c.269-.529.558-1.066.848-1.6,2.46-4.663,6.5-12.211,10.947-20.474l-57.6-29.031-9.361,16.379s-14.771-.96-27.949-1.178c-.02.006-.033,0-.041.012-8.116-.147-15.237-.142-17.061.25C155.7,375.617,148.566,383.13,151.15,385.671Z",
    transform: "translate(-150.037 -317.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984",
    transform: "translate(0 36.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M150.781,381.24c2.661,2.616,93.682,47.064,98.226,46.566,1.723-.18,9.943-13.548,16.273-29.676l-58.717-28.586s-41.335-.865-46.258.217C155.4,370.851,148.122,378.623,150.781,381.24Z",
    transform: "translate(-150.214 -349.06)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(3.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(0 18.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M152.822,375.435c15.44,7.077,77.051,37.074,91.777,45.242.119.067.079.151-.047.1-15.458-6.68-76.824-37.175-91.854-45.087C152.381,375.518,152.5,375.285,152.822,375.435Z",
    transform: "translate(-152.511 -364.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M162.327,369.308a13.649,13.649,0,0,1,7.309,8.183,13.221,13.221,0,0,1-.569,9.812c-.048.09-.217.01-.185-.09,2.044-6.4-.826-14.293-6.649-17.713A.107.107,0,0,1,162.327,369.308Z",
    transform: "translate(-148.123 -367.264)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M185.355,368.9c6.149,2.9,12.176,8.51,13.533,15.359.052.265-.326.336-.461.154A93.959,93.959,0,0,0,184.883,369.6.428.428,0,0,1,185.355,368.9Z",
    transform: "translate(-137.879 -367.464)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M181.5,368.582c6.149,2.9,12.176,8.51,13.533,15.357.052.266-.326.337-.461.154a93.949,93.949,0,0,0-13.544-14.812A.427.427,0,0,1,181.5,368.582Z",
    transform: "translate(-139.632 -367.609)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M177.635,368.261c6.149,2.9,12.177,8.512,13.533,15.359.054.266-.324.336-.461.154a93.948,93.948,0,0,0-13.544-14.812A.428.428,0,0,1,177.635,368.261Z",
    transform: "translate(-141.384 -367.754)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M173.776,367.943c6.148,2.9,12.176,8.51,13.533,15.359.052.265-.326.336-.461.154A93.951,93.951,0,0,0,173.3,368.643.428.428,0,0,1,173.776,367.943Z",
    transform: "translate(-143.136 -367.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M220.674,395.467c6.843,3.366,1.623,14.005-5.23,10.633S213.82,392.095,220.674,395.467Z",
    transform: "translate(-125.396 -355.679)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M183.511,364.7c1.218,5.861,4.933,10.989,7.812,16.121a.83.83,0,0,0,1.339.044.18.18,0,0,0,.276-.081,35.676,35.676,0,0,0,2.076-18.328c-.606-3.591-3.277-8-7.62-6.944C183.287,356.509,182.8,361.279,183.511,364.7Zm2.187-5.2c3.853-6.347,7.354,1.684,7.7,4.349a38.478,38.478,0,0,1,.22,5.21,106.782,106.782,0,0,1-.979,10.729c-1.259-2.607-2.732-5.083-4.086-7.641C186.934,369.1,183.573,363,185.7,359.5Z",
    transform: "translate(-138.56 -355.354)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M213.975,380.36c1.469-4.22-2.659-7.3-6.177-8.256a35.663,35.663,0,0,0-18.441.3.179.179,0,0,0-.108.268.829.829,0,0,0-.087,1.336c4.829,3.362,9.575,7.554,15.29,9.333C207.792,384.377,212.587,384.353,213.975,380.36ZM197.526,377.6c-2.415-1.6-4.737-3.3-7.21-4.807a106.943,106.943,0,0,1,10.774.064,38.361,38.361,0,0,1,5.163.721c2.62.6,10.276,4.859,3.586,8.08C206.15,383.44,200.405,379.506,197.526,377.6Z",
    transform: "translate(-136.009 -348.235)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988",
    transform: "translate(55.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M188.569,419.1l68.116,34.036s53.166-108.094,59-115.06c7.776-9.285,109.054,3.828,132.943-26.158,24.7-31.013,3.536-69.525,3.536-69.525l-77.095-.048s-.228,8.551,4.217,21.051c0,0-88.157-5.245-113.1,19C247.036,301.015,188.569,419.1,188.569,419.1Z",
    transform: "translate(-188.569 -239.199)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    transform: "translate(13.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M344.928,265.825a133.071,133.071,0,0,0-12.263-7.493,51,51,0,0,0-9.29-3.753c-2.248-.545-3.234-.71-1.124.286,1.207.571,3.52,1.672,5.671,2.694-.406-.013-.807-.025-1.2-.045-1.514-.079-3.032-.131-4.547-.17-2.963-.076-5.931-.057-8.9-.074-6.017-.035-11.972.534-17.973.835a.124.124,0,0,0,.006.247c5.988-.195,12,.124,18,.1,2.968-.012,5.93.073,8.9.128q2.172.041,4.346.077a34.944,34.944,0,0,0,3.682,0l1.653.784c4.358,2.055,8.708,4.2,12.906,6.565C344.922,266.08,345.052,265.91,344.928,265.825Z",
    transform: "translate(-153.677 -233.842)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M315.789,240.447c.784,3.638,1.455,7.3,2.367,10.909.417,1.655.829,3.338,1.394,4.951.478,1.361,1.22,2.92,2.763,3.273,1.78.406,2.344-1.111,2.248-2.6-.108-1.656-.474-3.325-.746-4.96-.313-1.886-.63-3.77-.907-5.662-.138-.945-.284-1.89-.412-2.838-.032-.238-.147-2.044-.259-2.565-.016.044-.045.084-.1.074l-.062-.01a.124.124,0,0,1-.106-.1c-.013-.143-.01-.172.1-.268a.137.137,0,0,1,.164-.006c.337.2.346.669.445,1.018.26.923.526,1.845.762,2.774.441,1.739.87,3.481,1.249,5.234s.747,3.506,1.117,5.259a8.165,8.165,0,0,1,.214,4.019,3.061,3.061,0,0,1-2.911,2.212c.058.121.129.234.179.358.145.361.249.743.369,1.112s.237.753.332,1.14a3.459,3.459,0,0,1,.086.561c.016.209-.033.411-.015.622a.3.3,0,0,1-.566.182c-.087-.188-.221-.334-.32-.515a3.247,3.247,0,0,1-.238-.614c-.111-.364-.2-.727-.282-1.1s-.177-.737-.233-1.109c-.033-.221-.033-.445-.045-.667a4.143,4.143,0,0,1-2.055-.861,6.963,6.963,0,0,1-2.043-3.369c-.494-1.519-.864-3.088-1.234-4.641a67.567,67.567,0,0,1-1.908-11.7A.334.334,0,0,1,315.789,240.447Z",
    transform: "translate(-144.625 -240.182)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M341.286,247.531c.266,1.8.413,3.616.766,5.4.345,1.751.758,3.5,1.272,5.21a18.457,18.457,0,0,0,2.044,4.724,17.423,17.423,0,0,0,3.381,3.683,29.935,29.935,0,0,0,8.314,5,39.717,39.717,0,0,0,4.66,1.537c.824.215,1.659.388,2.5.525a5.3,5.3,0,0,1,2.011.538.411.411,0,0,1-.061.7c-1.1.493-2.6.15-3.751-.007a27.49,27.49,0,0,1-3.98-.837,29.046,29.046,0,0,1-7.458-3.443,23.854,23.854,0,0,1-6.15-5.387,17.974,17.974,0,0,1-3.133-7.526,36.622,36.622,0,0,1-.763-10.107A.176.176,0,0,1,341.286,247.531Z",
    transform: "translate(-132.952 -236.909)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(0 167.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M198.171,355.39a42.61,42.61,0,0,1,5.471,2.319c1.893.865,3.789,1.727,5.668,2.623,3.7,1.765,7.365,3.58,10.994,5.474,7.308,3.817,14.6,7.674,21.8,11.684,3.754,2.089,11.83,6.537,12.174,6.981.166.212-.1.576-.329.475-7.511-3.293-14.838-6.956-22.18-10.6s-14.652-7.306-21.8-11.3c-1.979-1.107-3.926-2.265-5.89-3.4a49.536,49.536,0,0,1-6.139-3.728C197.767,355.781,197.9,355.311,198.171,355.39Z",
    transform: "translate(-197.866 -355.381)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M430.969,254.785a.255.255,0,0,0-.51.01c.147,16.74-2.44,35.458-15.324,47.465-14.129,13.166-34.51,14.738-52.852,14.584-10.529-.089-21.037-.356-31.567-.022-10.575.336-21.258.855-31.76,2.2a17.319,17.319,0,0,0-10.784,5.157c-2.911,3.005-5,6.716-7.148,10.274q-7.943,13.16-15.389,26.611-14.8,26.733-27.386,54.6-1.564,3.457-3.1,6.93c-.067.153.158.282.23.128q12.79-27.948,27.533-54.944,7.341-13.5,15.184-26.728c2.457-4.142,4.836-8.384,7.575-12.349,2.421-3.5,5.451-6.8,9.647-8.07a39.454,39.454,0,0,1,7.843-1.14q4.035-.371,8.074-.664,7.871-.576,15.761-.862c10.614-.387,21.211-.257,31.827-.065,18.43.334,38.563-.3,53.844-12.032a43.422,43.422,0,0,0,14.2-19.834c2.883-7.958,3.913-16.5,4.106-24.922C431.027,259,431.018,256.891,430.969,254.785Z",
    transform: "translate(-180.943 -233.662)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M313.986,305.135c-3.76.067-7.519.224-11.277.35a44.491,44.491,0,0,0-9.33.833c-2.844.708-5.105,1.053-7.433,4.234-2.908,3.974-18.734,34.547-25.38,48.084q-2.763,5.629-5.448,11.3c-1.844,3.905-3.477,7.908-5.313,11.815-.068.143.145.263.217.119,1.627-3.267,3.439-6.446,5.12-9.687s3.317-6.514,4.949-9.784q4.947-9.9,9.911-19.791c3.289-6.531,7.283-12.9,10.622-19.407,2.8-5.469,6.63-12.933,9.3-14.04a44.067,44.067,0,0,1,11.638-2.827c4.144-.291,8.291-.544,12.43-.9A.149.149,0,0,0,313.986,305.135Z",
    transform: "translate(-174.291 -210.692)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023",
    transform: "translate(94.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991",
    transform: "translate(100.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M380.292,185.637c3.536,13.977,10.136,30.159,6.9,44.747-2.55,11.43-10.963,20.5-20.238,27.123-20.41,14.55-51.58,22.3-71.888,3.248-8.109-7.613-12.995-25.937-3.974-34.864,4.638-4.574,10.835-6.686,16.542-9.564,7.535-3.773,12.371-9.434,14.534-17.62,4.237-15.946.621-26.243-1.217-42.174-.333-2.957-.24-5.959,2.123-9a20.288,20.288,0,0,1,8.225-7.061,20.151,20.151,0,0,1,9.184-3.526c7.081-.7,15.045,4.324,21.224,7.2,6.255,2.92,9.615,6.619,11.434,13.341C375.663,166.836,377.91,176.256,380.292,185.637Z",
    transform: "translate(-283.153 -136.885)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M362.821,186.511c-4.067-12.6-8.375-25.105-12.6-37.649-.025-.076-.147-.051-.124.029,3.181,10.421,6.216,20.874,9.534,31.257,3.251,10.177,7.293,20.416,9.642,30.841,5.272,23.4-16.92,37.932-37.134,40.888-.92.134-.6,1.583.324,1.418,17.665-3.154,37.4-13.466,38.78-33.65C371.993,208.6,366.145,196.814,362.821,186.511Z",
    transform: "translate(-262.571 -131.467)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M322.8,149.436a.2.2,0,0,0-.385.087c2.066,13.041,5.7,28.054.656,40.817a33.5,33.5,0,0,1-12.427,15.447c-4.443,2.972-9.553,4.2-14.421,6.241-19.036,7.972-13.722,34.8,2.838,42.281.349.157.632-.435.289-.609-11.807-6-18.172-20.007-12.118-32.5,4.859-10.023,18.175-9.9,26.268-16.43C330.272,191.233,327.054,168.115,322.8,149.436Z",
    transform: "translate(-284.12 -131.254)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(0 54.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M368.887,188.805c-8.739,18.883-38.59,62.685-52.973,64.683-12.726,1.767-44.227-5.554-54.84-11.383-4.878-2.68,7.4-38.831,15.586-37.114,10.235,2.145,24.086,7.2,33.573,7.783,3.357.208,19.527-11.341,48.012-30.1C368.838,175.7,373.809,178.169,368.887,188.805Z",
    transform: "translate(-194.836 -172.088)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992",
    transform: "translate(24.11 19.552)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M272.99,205.464s-25.338-3.919-26.64-3.679c-1.31.26-1.029,2.111-.869,3.578a13.624,13.624,0,0,0,1.105,2.437c1.906,3.762,5.121,10.482.015,12.007-6.718,2.005-13.97-13.088-14.734-15.623a8.187,8.187,0,0,1,.2-3.494c.913-4.134,3.782-10.162,8.662-11.716,6.688-2.134,14.331-1.205,21.021-.869Z",
    transform: "translate(-231.753 -187.613)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M272.892,205.464s-25.338-3.919-26.64-3.679c-1.31.26-1.029,2.111-.869,3.578a13.624,13.624,0,0,0,1.105,2.437c-5.176-2.511-10.885-5.307-14.518-7.11.913-4.134,3.782-10.162,8.662-11.716,6.688-2.134,14.331-1.205,21.021-.869Z",
    transform: "translate(-231.656 -187.613)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993",
    transform: "translate(5.784 7.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M279.605,241.868c-1.325-.708-8.137-2.719-17.345-5.909-2.475-7.112-9.061-20.7-10.789-24.308-1.237-4.34-6.355-12.915-6.754-12.721-.746.362-3.385,1.64-6.71,2.936-4.4,1.7-9.983,3.458-13.982,3.2-2.18-.144-3.868-.87-4.67-2.507-1.435-2.941,4.875-6.353,12-11.049,9.691-6.408,21.945-13.749,27.943-11.981,8.864,2.611,17.608,13.45,20.582,16.372,2.991,2.924,15.312,8.851,15.312,8.851C292.661,218.05,281.382,242.8,279.605,241.868Z",
    transform: "translate(-219.15 -179.264)",
    fill: "#d3766a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M244.179,199.712c-.108-.179-.211-.089-.131.134.256.7,1.352,3.823.672,4.16-1.185.589-8.275-3.237-11.529-4.32-.176-.058-.273.179-.1.224a51.435,51.435,0,0,1,4.779,2.284c1.493.742,5.876,3.328,7.366,2.587C246.23,204.285,244.608,200.41,244.179,199.712Z",
    transform: "translate(-207.078 -162.611)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M217.548,211.738c-.875.853-1.844,1.55-2.258,1.156l-.013-.015c-.382-.425.337-1.374,1.213-2.226Z",
    transform: "translate(-215.172 -157.6)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M227.37,227.1c-.913.891-7.858,1.6-10.422,1.474a1.264,1.264,0,0,1-1.069-1.067c-.058-2.536.832-9.508,1.748-10.4.622-.6,3.511-2.111,6.321-3.866,3.679-2.277,43.177-38.882,43.827-39.056s1.831.8,2.419,1.407,1.553,1.828,1.362,2.473c-.206.627-37.79,39.2-40.158,42.818C229.571,223.648,227.992,226.5,227.37,227.1Z",
    transform: "translate(-214.852 -174.166)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M226.905,213.81a.877.877,0,0,1-.35.205,33.481,33.481,0,0,1-5.969-4.8,21.93,21.93,0,0,1-3.7-4.92,1.112,1.112,0,0,1,.27-.484,3.622,3.622,0,0,1,.449-.356c.842,1.708,3.379,5.863,9.691,9.855A3.058,3.058,0,0,1,226.905,213.81Z",
    transform: "translate(-214.392 -160.866)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994",
    transform: "translate(10.9 30.479)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 2.874,
    height: 17.597,
    rx: 0.73,
    transform: "matrix(0.698, 0.716, -0.716, 0.698, 12.602, 0)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 1.678,
    height: 11.172,
    rx: 0.426,
    transform: "matrix(0.698, 0.716, -0.716, 0.698, 8.974, 4.369)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 0.492,
    height: 1.674,
    transform: "matrix(0.716, -0.698, 0.698, 0.716, 3.615, 9.597)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M259.743,227.02c-3.151-1.08-5.963-2.009-7.892-2.588-7.6-2.273-11.081-6-14.136-10.453-3.026-4.449-18.508-9.218-10.976-13.895s21.019,6.771,22.332,4.8a3.074,3.074,0,0,0-.116-2.172C250.682,206.318,257.268,219.908,259.743,227.02Z",
    transform: "translate(-210.848 -162.912)",
    fill: "#d3766a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    transform: "translate(130.713 5.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M305.07,200.447,336.375,213s9.886-13.772,14.281-22.165c5.816-11.106,3.055-15.869-11.274-10.313C329.794,184.235,305.07,200.447,305.07,200.447Z",
    transform: "translate(-305.07 -178.189)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M323.995,203.8c.361.074,3.619,1.256,3.827,1.409,1.122-1.649,2.223-3.314,3.363-4.949.57-.817,1.156-1.628,1.751-2.427.657-.881,1.357-1.918,1.938-2.7.09-.122.254-.019.176.112-.654,1.088-1.178,1.879-1.749,2.816-.51.838-1.043,1.668-1.589,2.482-1.16,1.723-2.321,3.61-3.564,5.274a34.188,34.188,0,0,1-4.2-1.909C323.892,203.879,323.938,203.792,323.995,203.8Z",
    transform: "translate(-296.511 -170.518)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M308.12,192.333c4.682,1.511,9.332,3.085,13.918,4.869q3.433,1.335,6.821,2.771c2.257.958,4.422,2.15,6.688,3.074.124.049.035.247-.089.19-2.212-1.041-4.589-1.79-6.856-2.707s-4.555-1.832-6.841-2.729c-4.563-1.79-9.127-3.591-13.729-5.278C307.9,192.477,307.995,192.292,308.12,192.333Z",
    transform: "translate(-303.753 -171.77)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(140.37 60.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M312.478,274.913l88.941,7.186s-22.763-77.595-41.095-97.182c-8.343-8.915-16.5-7.552-23.407-1.819-1.724,1.434-23.1,28.563-24.91,38.018-1.6,8.356,5.192,17.63,5.192,17.63Z",
    transform: "translate(-311.688 -178.513)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(0 18.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M325.674,191.558c-2.678,4.278-5.594,8.4-8.288,12.646a59.1,59.1,0,0,0-3.756,6.5,16.617,16.617,0,0,0-1.838,7.194,12.731,12.731,0,0,1,.142-3.8,17.412,17.412,0,0,1,1.14-3.645,49.318,49.318,0,0,1,3.645-6.671c1.284-1.934,2.6-3.868,3.962-5.738.221-.665.491-1.314.744-1.964a22.61,22.61,0,0,1,1.394-2.758,23.364,23.364,0,0,1-1.029,2.9c-.127.269-.238.523-.349.792C322.805,195.155,324.215,193.332,325.674,191.558Z",
    transform: "translate(-311.711 -191.558)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M383.682,229.3a59.725,59.725,0,0,1-10.832,3.417,11.5,11.5,0,0,1-3.315.131,5.135,5.135,0,0,1-3.024-1.338c-1.643-1.6-2.21-3.9-2.574-6.034a76.691,76.691,0,0,1-.625-7.721,3.067,3.067,0,0,0-.029-.378c-.073-1.687-.16-3.373-.334-5.045a34.249,34.249,0,0,0-1.163-6.427,15.683,15.683,0,0,0-2.937-5.758,11.9,11.9,0,0,0-5.22-3.708,17.777,17.777,0,0,0-6.427-.814,56.652,56.652,0,0,0-8.957,1.207,2.463,2.463,0,0,1-.32.058c-1.236.262-2.457.523-3.693.785-3.533.742-7.067,1.512-10.672,1.919.073-.1.145-.2.2-.305,3.5-.407,6.95-1.163,10.411-1.9,1.28-.276,2.559-.553,3.853-.814a2.26,2.26,0,0,1,.305-.058,53.186,53.186,0,0,1,8.855-1.221,18.574,18.574,0,0,1,6.558.814,12.439,12.439,0,0,1,5.394,3.81,16.122,16.122,0,0,1,2.981,5.889,34.248,34.248,0,0,1,1.163,6.5c.16,1.585.247,3.17.32,4.755.015.131.015.262.029.378a76.683,76.683,0,0,0,.611,7.983c.349,2.123.916,4.362,2.472,5.874,1.57,1.541,4,1.5,6.092,1.149a60.186,60.186,0,0,0,10.789-3.359Zm-52.708,37.979c-1.614-1.469-3.475-2.908-5.758-3.141a5.119,5.119,0,0,0-3.213.829,11.942,11.942,0,0,0-2.515,2.167,47.321,47.321,0,0,0-5.016,7.125l.291.029a47.025,47.025,0,0,1,4.929-6.965c1.425-1.57,3.315-3.126,5.5-2.893,2.152.218,4,1.614,5.583,3.068,2.864,2.69,5.293,5.816,7.982,8.724l.509.044C336.47,273.313,333.969,270.071,330.974,267.279Zm61.97-12.388c-.305.015-.625.044-.931.073-4.464.48-8.375,2.981-11.618,5.9a86.6,86.6,0,0,0-8.869,9.742c-2.2,2.632-4.362,5.307-6.79,7.706l.422.044c2.37-2.385,4.464-4.987,6.6-7.561a88.938,88.938,0,0,1,8.811-9.727c3.228-2.908,7.081-5.394,11.458-5.874.334-.029.669-.058,1-.073C393,255.051,392.973,254.978,392.944,254.891Zm-17.375-44.944c-4.2.727-7.866,3.213-10.905,6.078-.364.334-.712.683-1.061,1.032l-.32.32c-2.617,2.69-4.944,5.656-7.27,8.579-2.123,2.675-4.217,5.38-6.587,7.837-.087.087-.174.189-.276.276-.567.6-1.178,1.178-1.8,1.745a18.015,18.015,0,0,1-5.467,3.475,12.065,12.065,0,0,1-6.383.494,16.108,16.108,0,0,1-5.932-2.574,33.6,33.6,0,0,1-5-4.2c-3.141-3.053-5.86-6.529-9.16-9.466a14.849,14.849,0,0,0-3.548-2.414c-.015.1-.029.218-.044.32a13.665,13.665,0,0,1,3.4,2.312c3.257,2.923,5.976,6.4,9.1,9.495a34.484,34.484,0,0,0,5.06,4.246,15.932,15.932,0,0,0,6.063,2.632,12.34,12.34,0,0,0,6.572-.509,18.15,18.15,0,0,0,5.554-3.562c.683-.625,1.352-1.265,1.978-1.919.1-.087.189-.189.276-.276,2.312-2.443,4.362-5.1,6.441-7.721a105.461,105.461,0,0,1,7.052-8.39,3.318,3.318,0,0,1,.32-.32c.393-.407.8-.814,1.221-1.207,3.024-2.864,6.659-5.351,10.8-6.049C375.627,210.093,375.6,210.02,375.569,209.947ZM366.146,239.1c-1.4-1.8-3.62-2.632-5.7-3.228-3.5-.945-7.1-1.367-10.629-2.007a3.723,3.723,0,0,0-.393-.073c-.64-.131-1.28-.247-1.919-.393a34.606,34.606,0,0,1-6.267-1.89,16.011,16.011,0,0,1-5.394-3.562,12.019,12.019,0,0,1-3.083-5.613,17.992,17.992,0,0,1-.073-6.485,77.24,77.24,0,0,1,3.5-12.635c.7-2.108,1.41-4.231,2.05-6.383.029-.1.058-.218.087-.32a55.856,55.856,0,0,0,1.44-5.976,23.825,23.825,0,0,0-.131-10.236l-.218.131a23.642,23.642,0,0,1,.073,10.047,58.062,58.062,0,0,1-1.469,6.092,2.057,2.057,0,0,0-.1.32c-.625,2.079-1.323,4.158-2.021,6.223a79.362,79.362,0,0,0-3.548,12.694,18.317,18.317,0,0,0,.073,6.6,12.317,12.317,0,0,0,3.155,5.787,16.237,16.237,0,0,0,5.525,3.635,34.39,34.39,0,0,0,6.325,1.89c.567.131,1.149.247,1.716.349.131.029.262.044.393.073,3.62.669,7.285,1.076,10.818,2.021,2.065.582,4.231,1.4,5.554,3.112,1.352,1.745,1.032,4.158.451,6.194-1.236,4.2-3.417,8.055-5.394,11.967A80.194,80.194,0,0,0,355.6,269.46a20.074,20.074,0,0,0-1.061,6.485,11.488,11.488,0,0,0,.16,1.57l.2.015a9.608,9.608,0,0,1-.175-1.585,19.807,19.807,0,0,1,1.076-6.427,81.112,81.112,0,0,1,5.38-11.981c1.977-3.911,4.173-7.75,5.438-12a11.837,11.837,0,0,0,.523-3.272A5.176,5.176,0,0,0,366.146,239.1Z",
    transform: "translate(-311.666 -177.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    transform: "translate(8.863 58.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M338.319,218.646a69.857,69.857,0,0,0-10.3,1.076c-1.687.327-3.346.73-5.006,1.17-.827.22-1.656.41-2.491.6a11,11,0,0,1-2.656.34.062.062,0,0,0-.006.124,18.65,18.65,0,0,0,2.533.1,18.142,18.142,0,0,0,2.44-.313c1.713-.315,3.411-.711,5.12-1.044,3.45-.673,6.9-1.345,10.389-1.768C338.506,218.912,338.482,218.639,338.319,218.646Z",
    transform: "translate(-317.807 -218.646)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M342.969,221.381a75.34,75.34,0,0,0-8.494-.912c-1.426-.067-2.843-.051-4.269,0-.68.025-1.361.063-2.04.109-.747.051-1.489.2-2.236.241-.079,0-.086.125-.006.124.707-.016,1.419.084,2.124.109s1.421.044,2.13.068c1.421.049,2.84.113,4.262.15,2.845.071,5.678.172,8.519.342C343.113,221.624,343.115,221.4,342.969,221.381Z",
    transform: "translate(-314.148 -217.838)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(128.606 3.316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(24.706 34.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M344.653,187.924c.092,1.608-4.2,13.483-11.167,15.189-2.268.552-5.835-11.7-5.835-11.7l-.47-.843-6.569-11.824,12.054-13.932,1.775-1.9s1.583,3.354,3.514,7.549c.092.195.182.388.275.6.116.234.228.455.326.678.3.624.6,1.261.883,1.9.218.487.435.96.646,1.48.227.516.435,1.021.66,1.537A87.521,87.521,0,0,1,344.653,187.924Z",
    transform: "translate(-320.612 -162.914)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M337.955,170.463a27.133,27.133,0,0,1-10.774,20.106l-6.569-11.824,12.054-13.932,1.775-1.9S336.025,166.268,337.955,170.463Z",
    transform: "translate(-320.612 -162.914)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M305.341,170.95c.768,23.727,15.065,25.947,20.182,25.775,4.644-.156,20.438-1.274,22.126-24.952s-9.585-30.824-20.225-31.03S304.574,147.223,305.341,170.95Z",
    transform: "translate(-302.855 -138.451)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    transform: "translate(4.126 24.872)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M307.874,159.462a15.584,15.584,0,0,0,1.583-.425,2.651,2.651,0,0,0,1.533-.742.846.846,0,0,0-.057-1.029,2.1,2.1,0,0,0-2.089-.377,3.073,3.073,0,0,0-1.868,1.191A.9.9,0,0,0,307.874,159.462Z",
    transform: "translate(-306.299 -156.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M319.788,158.757a15.548,15.548,0,0,1-1.62-.25,2.654,2.654,0,0,1-1.6-.571.843.843,0,0,1-.055-1.029,2.092,2.092,0,0,1,2.034-.6,3.074,3.074,0,0,1,1.988.981A.9.9,0,0,1,319.788,158.757Z",
    transform: "translate(-301.962 -156.271)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006",
    transform: "translate(14.309 6.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    transform: "translate(0 0.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M316.377,162.128c.01-.061.128.073.128.14,0,1.617.27,3.469,1.748,3.959.047.016.044.1-.01.092C316.452,166.122,316.117,163.659,316.377,162.128Z",
    transform: "translate(-316.299 -160.385)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M317.759,160.935c2.593-.279,2.957,4.926.555,5.185C315.95,166.373,315.585,161.168,317.759,160.935Z",
    transform: "translate(-316.291 -160.925)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M318.115,161.189c.475.262.957.75,1.509.766.638.019,1.079-.56,1.457-1.114.039-.057.087-.015.093.054.084,1-.227,2.047-1.285,2.27-.967.205-1.729-.63-2.049-1.614C317.781,161.368,317.923,161.083,318.115,161.189Z",
    transform: "translate(-315.606 -160.815)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    transform: "translate(0 7.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(1.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M310.624,162.327c-.017-.061-.119.086-.113.151.177,1.608.109,3.479-1.307,4.128-.044.019-.033.1.02.089C310.983,166.3,311.049,163.821,310.624,162.327Z",
    transform: "translate(-307.175 -160.756)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M309.679,161.242c-2.607,0-2.4,5.218.01,5.214C312.066,166.45,311.864,161.238,309.679,161.242Z",
    transform: "translate(-307.8 -161.242)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M309.215,161.561c-.4.292-.79.811-1.281.862-.568.06-1.012-.489-1.4-1.015-.041-.054-.08-.009-.078.06.01,1,.381,2.023,1.345,2.178.88.14,1.489-.74,1.688-1.742C309.527,161.718,309.376,161.443,309.215,161.561Z",
    transform: "translate(-306.458 -161.177)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M318.084,171.228c-.342.42-.664.981-1.242,1.1a4.258,4.258,0,0,1-1.772-.205.058.058,0,0,0-.061.092,2.183,2.183,0,0,0,2.14.635,1.725,1.725,0,0,0,1.1-1.567C318.259,171.186,318.133,171.167,318.084,171.228Z",
    transform: "translate(-302.582 -149.496)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009",
    transform: "translate(9.104 17.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M312.719,170.266a6.592,6.592,0,0,0,2.63,2.056,2.979,2.979,0,0,0,1.8.119c1.3-.337,1.341-1.533,1.105-2.558a7.093,7.093,0,0,0-.577-1.567A8.54,8.54,0,0,1,312.719,170.266Z",
    transform: "translate(-312.719 -168.316)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M314.528,171.832a2.979,2.979,0,0,0,1.8.119c1.3-.337,1.341-1.533,1.105-2.558A3.062,3.062,0,0,0,314.528,171.832Z",
    transform: "translate(-311.898 -167.827)",
    fill: "#ff9cbd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(5.735 0.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M313.082,172.4s-.192,2.43-.126,3.567c.007.106.285.141.672.141.019,0,.029.012.045,0a5.41,5.41,0,0,0,5.13-2.325c.073-.116-.078-.225-.177-.148a8.16,8.16,0,0,1-4.852,1.7c-.1-.31.468-4.15.286-4.153a9.884,9.884,0,0,0-2.547.736c.254-5.073,1.319-10.063,1.5-15.117a.155.155,0,0,0-.3-.057c-1.486,5.152-1.906,10.982-2.3,16.214C310.347,173.606,312.638,172.616,313.082,172.4Z",
    transform: "translate(-310.402 -156.638)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M345.843,174.378c-2.579-.163-9.274-7.289-9.432-19.754,0,0,.916,11.183,1.751,12.826s-3.741-4.01-4.01-14.062c0,0-5.582,4-10.334,5.31s-7.657,1.256-7.994.912,6.655-2.518,8.553-4.689c0,0-12.65,5.822-18.472,6.243-.673.049-1.423-13.8,7.6-19.641s23.251.557,27.069,4.273c0,0,4.5.657,9.364,7.333S348.623,174.554,345.843,174.378Z",
    transform: "translate(-302.751 -139.165)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(0 26.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M320.63,172.072a7.46,7.46,0,0,1-6.8-8.045h0a7.453,7.453,0,1,1,6.8,8.045Zm-5.81-7.962a6.454,6.454,0,1,0,6.969-5.893,6.382,6.382,0,0,0-1.6.065A6.467,6.467,0,0,0,314.82,164.109Z",
    transform: "translate(-298.998 -157.197)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M309.536,172.572c-3.053.15-5.7-3.068-5.9-7.17a8.906,8.906,0,0,1,1.317-5.28,4.642,4.642,0,0,1,7.936-.388,8.891,8.891,0,0,1,1.826,5.125c.19,3.884-1.879,7.19-4.691,7.66A4.137,4.137,0,0,1,309.536,172.572Zm-3.753-11.9a7.91,7.91,0,0,0-1.156,4.686c.174,3.554,2.356,6.345,4.861,6.223s4.4-3.115,4.231-6.67a7.914,7.914,0,0,0-1.61-4.55,3.972,3.972,0,0,0-3.253-1.674,3.272,3.272,0,0,0-.377.041A4.113,4.113,0,0,0,305.783,160.668Z",
    transform: "translate(-303.621 -156.975)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M315.571,163.082l.6-.794c-1.175-.893-3.847-2.04-5.569-.006l.76.643C312.9,161.1,315.463,163,315.571,163.082Z",
    transform: "translate(-300.45 -155.403)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M343.023,164.146l.861-.5c-.234-.4-2.342-3.93-4.582-4.183-2.094-.23-15.368,1.674-15.93,1.755l.142.986c3.805-.55,14.059-1.932,15.676-1.751C340.669,160.619,342.457,163.177,343.023,164.146Z",
    transform: "translate(-294.653 -156.177)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(39.518 27.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M336.4,172.675a4.942,4.942,0,0,1-1.059.412,3.643,3.643,0,0,1-1.108.161,3.266,3.266,0,0,1-1.41-.276,3.9,3.9,0,0,1-.973-.582,4.581,4.581,0,0,1-1.053-1.217l.552-6.453s4.273-7.971,7.823-6.533C342.739,159.625,340.15,170.751,336.4,172.675Z",
    transform: "translate(-330.799 -158.014)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M337.7,160.31a.055.055,0,0,1,.033.1c-2.614,1.441-3.757,4.163-4.455,6.925.7-1.114,1.742-1.8,3.221-.995.077.042.022.163-.057.156a2.472,2.472,0,0,0-2.6,1.178,11.959,11.959,0,0,0-1.031,2.338c-.1.26-.558.182-.5-.112l.014-.067C331.838,166.342,333.976,161.113,337.7,160.31Z",
    transform: "translate(-330.137 -156.971)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M335.031,167.812a1.1,1.1,0,1,1-1.008-1.184A1.1,1.1,0,0,1,335.031,167.812Z",
    transform: "translate(-329.875 -154.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M336.238,166.385a.777.777,0,1,1-.712-.838A.776.776,0,0,1,336.238,166.385Z",
    transform: "translate(-329.035 -154.594)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    transform: "translate(60.132 62.638)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(0 1.154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M369.261,188.151c16.173,25.057,37.452,66.975,25.867,75.01-19.048,13.211-71.913,17.444-84,17.919-5.218.205-12.839-34.4-9.037-38.494s59.223-2.722,59.885-6.076c.374-1.9-2.78-18.735-6.516-39.667C351.149,172.709,364.634,180.981,369.261,188.151Z",
    transform: "translate(-236.307 -180.757)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(0 57.89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M331.573,222.457s-15.824-1.4-26.214-1.828c-5.8-.24-15.772.237-20.11,2.009-6.491,2.652-31.942,17.884-28.381,24.135,3.224,5.658,23.427-10.206,23.427-10.206s-21.8,14.2-16.669,20.3,25.576-14.86,25.576-14.86-22.073,15.1-15.785,20.55c4.753,4.121,24.339-13.819,24.339-13.819S278.872,261.85,283.577,266.3c5.2,4.915,24.317-10.51,24.317-10.51,13.861,9.293,24.263,8.047,31.556,6.278C341.216,261.639,331.573,222.457,331.573,222.457Z",
    transform: "translate(-256.527 -220.571)",
    fill: "#d3766a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017",
    transform: "translate(7.875 10.591)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M285.06,227.865c-2.622,1.575-5.285,3.154-7.757,4.957s-4.884,3.695-7.177,5.72a52.232,52.232,0,0,0-8.173,8.73c4.644-5.391,13.394-11.985,15.868-13.79s4.845-3.724,7.312-5.525C285.194,227.911,285.123,227.827,285.06,227.865Z",
    transform: "translate(-261.943 -227.855)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M288.294,233.923c-3.261,2.158-6.577,4.179-9.742,6.481s-5.94,4.74-8.923,7.241c-.23.193-.051.253.188.068,3.083-2.38,6.114-4.343,9.224-6.686s6.129-4.81,9.31-7.032C288.4,233.962,288.344,233.889,288.294,233.923Z",
    transform: "translate(-258.502 -225.105)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M291.748,238.415a87.4,87.4,0,0,0-14.137,11.051c-.22.2.02.252.257.06,4.63-3.762,8.236-6.745,13.988-10.931C291.945,238.529,291.857,238.351,291.748,238.415Z",
    transform: "translate(-254.869 -223.067)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M328.317,222.017c-3.679-.313-7.676-.131-11.461-.273-3.3-.122-6.393-.571-9.608-.782-6.591-.43-16.314-1.047-22.869,0-4.744.756-10.627,4.627-13.969,6.2-.148.07-.032.272.113.221,6.267-2.249,10.052-4.942,15.729-5.758,6.527-.936,23.559.346,30.123.723,3.841.22,8.077-.173,11.923-.032A.149.149,0,0,0,328.317,222.017Z",
    transform: "translate(-250.255 -162.766)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(117.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M373.547,220.311l-33.6-2.883s-2.63-16.746-2.779-26.219c-.195-12.535,4.414-15.546,14.71-4.137C358.763,194.708,373.547,220.311,373.547,220.311Z",
    transform: "translate(-337.159 -179.964)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M343.771,209.956c-.355-.1-3.8-.506-4.051-.464-.26-1.977-.494-3.959-.776-5.934-.14-.986-.3-1.973-.471-2.955-.189-1.083-.348-2.323-.516-3.28a.1.1,0,1,0-.206.02c.093,1.266.2,2.207.292,3.3.079.979.182,1.96.3,2.931.26,2.062.448,4.269.808,6.313a34.037,34.037,0,0,0,4.612.188C343.831,210.071,343.828,209.972,343.771,209.956Z",
    transform: "translate(-336.891 -172.129)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M369.213,206.188c-4.861-.758-9.722-1.444-14.62-1.915q-3.664-.353-7.338-.595c-2.446-.16-4.916-.07-7.354-.266a.1.1,0,0,0-.009.209c2.444.067,4.9.468,7.341.669s4.893.414,7.337.641c4.881.455,9.767.9,14.636,1.466C369.342,206.413,369.344,206.208,369.213,206.188Z",
    transform: "translate(-335.962 -169.318)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029",
    transform: "translate(101.312 333.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 489.705,
    height: 17.415,
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    transform: "translate(17.528 17.42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 454.649,
    height: 17.41,
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(10.526 34.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M95.881,515.149H88.842L109.329,270.8H127.3Z",
    transform: "translate(-88.842 -270.796)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M121.32,270.8l-2.1,16.349H101.994L103.36,270.8Z",
    transform: "translate(-82.871 -270.795)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    transform: "translate(440.725 34.83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M416.126,515.149h7.039L402.678,270.8H384.712Z",
    transform: "translate(-384.712 -270.796)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M384.714,270.8l2.1,16.349h17.223L402.675,270.8Z",
    transform: "translate(-384.71 -270.795)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    transform: "translate(196.344 266.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M173.962,267.888H274.978l-24.536-67.409H149.427Z",
    transform: "translate(-145.841 -200.479)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M171.5,267.888H272.516L247.98,200.479H146.965Z",
    transform: "translate(-146.959 -200.479)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M146.961,200.482,171.5,267.89h40.858l-55.941-67.409Z",
    transform: "translate(-146.961 -200.477)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(6.543 48.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M151.461,252.807h12.295L174.79,233.7H162.495Z",
    transform: "translate(-151.461 -233.695)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M170.951,233.7v19.115H159.917Z",
    transform: "translate(-147.622 -233.695)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031",
    transform: "translate(75.503 48.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M198.888,252.807h12.295L222.217,233.7H209.922Z",
    transform: "translate(-198.888 -233.695)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M218.378,233.7v19.115H207.344Z",
    transform: "translate(-195.049 -233.695)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    transform: "translate(313.812 279.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(53.302 50.384)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 81.648,
    height: 3.662,
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 41.095,
    height: 3.662,
    fill: "#a6a6a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M317.725,263.715H238.153l-10.4-54.043h79.572Z",
    transform: "translate(-227.75 -209.672)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M265.051,229.768a4.367,4.367,0,0,1-4.42,4.843,5.392,5.392,0,0,1-5.266-4.843,4.367,4.367,0,0,1,4.419-4.843A5.392,5.392,0,0,1,265.051,229.768Z",
    transform: "translate(-215.22 -202.747)",
    fill: "#a6a6a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(138.978 188.766)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036",
    transform: "translate(19.873 4.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M123.792,281.179l-2.617-.343L134.645,178.36l48.9-26.838,1.269,2.313-47.731,26.2Z",
    transform: "translate(-121.174 -148.956)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M128.719,171.716a3.722,3.722,0,1,0,3.722-3.722A3.722,3.722,0,0,0,128.719,171.716Z",
    transform: "translate(-117.749 -141.477)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M161.591,153.479a3.722,3.722,0,1,0,3.721-3.722A3.721,3.721,0,0,0,161.591,153.479Z",
    transform: "translate(-102.825 -149.757)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    transform: "translate(76.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M190.874,158.14l-17.492,19.527-8.074-9.971-4.917-6.08,13.115-14.625,6.578,4.224Z",
    transform: "translate(-160.392 -146.991)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M189.339,156.821l-17.492,19.527-8.074-9.971L178.55,149.9Z",
    transform: "translate(-158.857 -145.673)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M214.647,166.693l-30.5,34.042-20.257-25.842,22.859-25.511Z",
    transform: "translate(-158.806 -145.906)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M152.64,251.269H107.507l2.77-14.178H149.87Z",
    transform: "translate(-107.507 -106.085)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(64.454 58.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(306.669)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M328.51,74.609l-46.662,46.323a8.092,8.092,0,1,1-11.4-11.484l46.646-46.337Z",
    transform: "translate(-266.764 -55.185)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M316.526,74.61,303.263,87.78,294.443,73.7l10.666-10.592Z",
    transform: "translate(-254.781 -55.185)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M267.761,109.107h0a2.05,2.05,0,0,1,.009-2.9l10.555-10.482,2.891,2.911L270.66,109.117A2.049,2.049,0,0,1,267.761,109.107Z",
    transform: "translate(-267.165 -40.378)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M281.22,98.632l-10.563,10.489a2.051,2.051,0,0,1-2.883-2.918l1.78-1.767,8.769-8.708Z",
    transform: "translate(-267.164 -40.377)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 24.22,
    height: 11.421,
    transform: "matrix(0.705, 0.71, -0.71, 0.705, 48.114, 4.545)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M310.425,81.069,299.017,69.581l9.637-9.57a8.1,8.1,0,0,1,11.449.041h0a8.1,8.1,0,0,1-.041,11.447Z",
    transform: "translate(-252.704 -57.66)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M299.59,91.064l-17.335,17.213a8.056,8.056,0,0,1-9.8,1.217l-1.794,1.781a2.051,2.051,0,0,1-2.883-2.918l1.78-1.767a8.056,8.056,0,0,1,1.285-9.8l5.851-5.81Z",
    transform: "translate(-267.164 -42.531)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "translate(0 135.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(7.286 71.411)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 25.686,
    height: 90.385,
    transform: "translate(90.385 0) rotate(90)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(14.404 3.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 19.299,
    height: 12.502,
    transform: "translate(73.117 0) rotate(90)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 19.299,
    height: 12.502,
    transform: "translate(57.963 0) rotate(90)",
    fill: "#ffc727",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 19.299,
    height: 12.502,
    transform: "translate(42.809 0) rotate(90)",
    fill: "#ffc727",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 19.299,
    height: 12.502,
    transform: "translate(27.655 0) rotate(90)",
    fill: "#ffc727",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 19.299,
    height: 12.502,
    transform: "translate(12.502 0) rotate(90)",
    fill: "#ffc727",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042",
    transform: "translate(14.404 3.194)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 19.299,
    height: 12.502,
    transform: "translate(73.117 0) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 19.299,
    height: 12.502,
    transform: "translate(57.963 0) rotate(90)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 19.299,
    height: 12.502,
    transform: "translate(42.809 0) rotate(90)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 19.299,
    height: 12.502,
    transform: "translate(27.655 0) rotate(90)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    width: 19.299,
    height: 12.502,
    transform: "translate(12.502 0) rotate(90)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M65.989,210.69a1.631,1.631,0,1,1,1.631-1.631A1.631,1.631,0,0,1,65.989,210.69Z",
    transform: "translate(-59.859 -196.215)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(0 15.596)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 25.686,
    height: 90.385,
    transform: "translate(63.911 0) rotate(45)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    transform: "translate(12.443 4.284)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329",
    "data-name": "Rectangle 329",
    width: 19.299,
    height: 12.502,
    transform: "translate(51.701 0) rotate(45)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330",
    "data-name": "Rectangle 330",
    width: 19.299,
    height: 12.502,
    transform: "translate(40.986 10.715) rotate(45)",
    fill: "#ffc727",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    width: 19.299,
    height: 12.502,
    transform: "translate(30.271 21.43) rotate(45)",
    fill: "#ffc727",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_332",
    "data-name": "Rectangle 332",
    width: 19.299,
    height: 12.502,
    transform: "matrix(0.707, 0.707, -0.707, 0.707, 19.555, 32.146)",
    fill: "#ffc727",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    width: 19.299,
    height: 12.502,
    transform: "translate(8.84 42.861) rotate(45)",
    fill: "#ffc727",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045",
    transform: "translate(12.443 4.284)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 19.299,
    height: 12.502,
    transform: "translate(51.701 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_335",
    "data-name": "Rectangle 335",
    width: 19.299,
    height: 12.502,
    transform: "translate(40.986 10.715) rotate(45)",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_336",
    "data-name": "Rectangle 336",
    width: 19.299,
    height: 12.502,
    transform: "translate(30.271 21.43) rotate(45)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_337",
    "data-name": "Rectangle 337",
    width: 19.299,
    height: 12.502,
    transform: "matrix(0.707, 0.707, -0.707, 0.707, 19.555, 32.146)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_338",
    "data-name": "Rectangle 338",
    width: 19.299,
    height: 12.502,
    transform: "translate(8.84 42.861) rotate(45)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M67.142,210.211a1.631,1.631,0,1,1,0-2.306A1.63,1.63,0,0,1,67.142,210.211Z",
    transform: "translate(-52.573 -140.4)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(0.573)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_339",
    "data-name": "Rectangle 339",
    width: 25.686,
    height: 90.385,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(3.194 2.865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_340",
    "data-name": "Rectangle 340",
    width: 19.299,
    height: 12.502,
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 19.299,
    height: 12.502,
    transform: "translate(0 15.153)",
    fill: "#ffc727",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 19.299,
    height: 12.502,
    transform: "translate(0 30.307)",
    fill: "#ffc727",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 19.299,
    height: 12.502,
    transform: "translate(0 45.461)",
    fill: "#ffc727",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 19.299,
    height: 12.502,
    transform: "translate(0 60.615)",
    fill: "#ffc727",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M68.947,209.374a2.642,2.642,0,1,1-2.642-2.642A2.642,2.642,0,0,1,68.947,209.374Z",
    transform: "translate(-53.462 -125.12)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(502.587 162.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M462.743,247.414H401.908V169.321h45.17l15.665,14.88Z",
    transform: "translate(-401.908 -169.321)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 60.835,
    height: 22.853,
    transform: "translate(0 55.241)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M401.908,213.069l19.245-18.436L438.6,213.069Z",
    transform: "translate(-401.908 -157.829)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M418.9,216.33l22.852-28.879,13.269,16.769V216.33Z",
    transform: "translate(-394.191 -161.09)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M419.868,188.4a6.819,6.819,0,1,1-6.819-6.819A6.819,6.819,0,0,1,419.868,188.4Z",
    transform: "translate(-399.946 -163.754)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M432.973,169.321l15.665,14.88H432.973Z",
    transform: "translate(-387.803 -169.321)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    transform: "translate(13.832 60.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M411.718,219.664a.409.409,0,0,1,.523.263,3.3,3.3,0,0,0,6.436-.995v-7.655a.418.418,0,1,1,.836,0v7.655a4.137,4.137,0,0,1-8.073,1.272A.432.432,0,0,1,411.718,219.664Z",
    transform: "translate(-411.421 -210.685)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M419.257,211.278a.424.424,0,0,1,.419-.419h3.453a3.479,3.479,0,0,1,0,6.957l-3.017.035v4.8a.428.428,0,0,1-.855,0ZM423.129,217a2.641,2.641,0,0,0,0-5.282h-3.017V217Z",
    transform: "translate(-407.863 -210.685)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M432.124,217.627a.418.418,0,0,1-.436-.419.432.432,0,0,1,.436-.436h3.82a.438.438,0,0,1,.382.436v4.256a.481.481,0,0,1-.157.314,6.256,6.256,0,1,1-3.94-11.039,6.384,6.384,0,0,1,3.959,1.377.435.435,0,0,1,.052.593.453.453,0,0,1-.611.07,5.391,5.391,0,1,0-3.4,9.486,5.483,5.483,0,0,0,3.227-1.045v-3.593Z",
    transform: "translate(-404.855 -210.739)",
    fill: "#a6a6a6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicDesign);
export default __webpack_public_path__ + "static/media/graphic-design.be12bb50c93871f6f99b4343ca68871c.svg";
export { ForwardRef as ReactComponent };